export default {
  en: {
    "inventory.label.EditGRV": "Edit GRV",
    "inventory.label.Edit_MRN": "Edit MRN",
    "inventory.label.CreateMRN": "Create MRN",
    "inventory.label.DeleteItemDetail": "Delete Item Detail",
  "inventory.label.EditQuality": "Edit Quality",
  "inventory.label.Quality": "Quality",
  "inventory.label.ViewTraker": "View Tracker",
  "inventory.label.EntityName": "Entity Name",
  "inventory.label.ItemDescription": "Item Description",
  "inventory.label.ItemCode": "Item Code",
  "inventory.label.AccountNumber": "Account Number",
  "inventory.label.ChipId": "Chip Id",
  "inventory.label.IsPairing": "Is Pairing",
  "inventory.label.PairedItemId": "Paired Item Id",
  "inventory.label.PairedItem": "Paired Item",
  "inventory.label.WarrantyDate": "Warranty Date",
  "inventory.label.ItemModel": "Item Model",
  "inventory.label.status": "Status",
  "inventory.label.EditItemDetail": "Edit Item Detail",
  "inventory.label.CreateStockUpload": "Create Stock Upload",
  "inventory.label.SelectStatus": "Select Status",
  "inventory.label.SelectDescription": "Select Description",
  "inventory.label.SelectBusinessEntity": "Select Business Entity",
  "inventory.label.Warranty": "Warranty",
  "inventory.label.SupplierCode": "Supplier Code",
  "inventory.label.GrnId": "GRN Id",
  "inventory.label.SerialNo": "Serial No",
  "inventory.label.ViewItemDetail": "View Item Detail",
  "inventory.label.Office": "Office",
    "inventory.label.RefType": "Ref Type",
  "inventory.label.TransactionDate": "Transaction Date",
  "inventory.label.Movement": "Movement",
  "inventory.label.FromOffice": "From Office",
  "inventory.label.ToOffice": "To Office",
  "inventory.label.TrackHistory": "Track History",
  "inventory.label.SerialNumber": "Serial Number",
  "inventory.label.ProvisionSerialNumber": "Provision Serial Number",
  "inventory.label.EditItemDetail": "Edit Item Detail",
    "inventory.label.Download_Uploaded_File": "Download Uploaded File",
    "inventory.label.Download_Log_File": "Download Log File",
    "inventory.label.Description": "Description",
    "inventory.label.Browse_file_to_Upload": "Browse file to Upload",
    "inventory.label.Download_From_here": "Download From here",
    "inventory.label.SelectItem": "Select Item",
    "inventory.label.SelectModel": "Select Model",
    "inventory.label.Browse_file_to_Upload": "Browse file to Upload",
    "inventory.label.Download_From_here": "Download From here",
    "inventory.label.MRN_Id": "MRN Id",
    "inventory.label.Type": "Type",
    "inventory.label.CartoonTransfer": "Cartoon Transfer",
    "inventory.label.Are_you_sure_?": "Are you sure?",
  "inventory.label.Done": "Done",
  "inventory.label.RefType": "Ref Type",
  "inventory.label.Movement": "Movement",
  "inventory.label.TransactionDate": "Transaction Date",
  "inventory.label.ToOffice": "To Office",
  "inventory.label.FromOffice": "From Office",
  "inventory.label.TrackHistory": "Track History",
  "inventory.label.SerialNumber": "Serial Number",
  "inventory.label.ProvisionSerialNumber": "Provision Serial Number",
  "inventory.label.SelectItem": "Select Item",
  "inventory.label.Quality": "Quality",
  "inventory.label.EditItemDetail": "Edit Item Detail",
  "inventory.label.Assets": "Assets",
  "inventory.label.NoGenerator": "No Generator",
  "inventory.label.Edit": "Edit",
  "inventory.label.CreateStockUpload": "Create Stock Upload",
  "inventory.label.Delete": "Delete",
  "inventory.label.View": "View",
  "inventory.label.SelectStatus": "Select Status",
  "inventory.label.SelectDescription": "Select Description",
  "inventory.label.SelectBusinessEntity": "Select Business Entity",
    "inventory.label.EditItemSale": "Edit Item Sale",
  "inventory.label.Item": "Item",
  "inventory.label.TotalItemPrice": "Total Item Price",
  "inventory.label.UnitPrice": "Unit Price",
  "inventory.label.RequestedQuantity": "Requested Quantity",
  "inventory.label.Charge": "Charge",
  "inventory.label.To_ORG": "To ORG",
  "inventory.label.ToOrganization": "To Organization",
  "inventory.label.FromOrganization": "From Organization",
  "inventory.label.From_ORG": "From ORG",
  "inventory.label.Type": "Type",
  "inventory.label.Notes": "Notes",
    "inventory.label.SelectSearch": "Select Search",
  "inventory.label.CreateGRV": "Create GRV",
  "inventory.label.Type": "Type",
  "inventory.label.Item": "Item",
  "inventory.label.Notes": "Notes",
  "inventory.label.PurchasedFrom": "Purchased From",
  "inventory.label.PurchaseBy": "Purchase By",
  "inventory.label.Charge": "Charge",
  "inventory.label.TotalItemPrice?": "Total Item Price?",
  "inventory.label.DiscountType": "Discount Type",
  "inventory.label.DiscountRate": "Discount Rate",
  "inventory.label.UnitPrice": "Unit Price",
    "inventory.label.View_GRV": "View GRV",
  "inventory.label.Delete": "Delete",
  "inventory.label.DeleteItemModel": "Delete Item Model",
  "inventory.label.View_MRN": "View MRN",
  "inventory.label.View_ItemSales": "View Item Sales",
    "inventory.label.CreateNewContract": "Create New Contract",
  "inventory.label.EditFeeMaster": "Edit Fee Master",
  "inventory.label.GRVId": "GRV Id",
  "inventory.label.SerialNo": "Serial No",
  "inventory.label.MRNId": "MRN Id",
  "inventory.label.SalesId": "Sales Id",
  "inventory.label.Are_you_sure?": "Are you sure?",
  "inventory.label.DeleteItemSale": "Delete Item Sale",
  "inventory.label.delete": "Delete",
  "inventory.label.MoveCarton": "Move Carton",
  "inventory.label.MoveItems": "Move Items",
  "inventory.label.BulkStockTransfer": "Bulk Stock Transfer",
  "inventory.label.Create_MRN/GRV": "Create MRN/GRV",
  "inventory.label.CreateItemSale": "Create Item Sale",
    "entity.label.Edit": "Edit",
  "entity.label.Delete": "Delete",
  "entity.label.DeleteItemModel": "Delete Item Model",
  "entity.label.Item": "Item",
  "entity.label.DeleteItem": "Delete Item",
    "inventory.label.DeleteItemDetails": "Delete Item Details",
    "inventory.label.header": "Goods Receipt",
    "inventory.label.id": "Id",
    "inventory.label.Purchase Date": "Purchase Date",
    "inventory.label.Supplier Code": "Supplier Code",
    "inventory.label.Entity Name": "Entity Name",
    "inventory.label.Save": "Save",
    "inventory.label.Cancel": "Cancel",
    "inventory.label.Edit": "Edit",
    "inventory.label.Ok": "Ok",
    "inventory.label.Reset": "RESET",
    "inventory.label.Update": "Update",
    "inventory.label.PinNo": "Pin No",
    "inventory.label.Delete": "Delete",
    "inventory.label.Value": "Value",
    "inventory.label.Confirm": "Confirm",
    "inventory.label.PinType": "Pin Type",
    "inventory.label.CustomerId": "Customer Id",
    "inventory.label.SerialNo": "Serial No",
    "inventory.label.OfficeId": "Office Id",
    "inventory.label.BatchName": "Batch Name",
    "inventory.label.ManageVoucherPins": "Manage Voucher Pins",
    "inventory.label.ContractType": "Contract Type",
    "inventory.label.ContractUnit": "Contract Unit",
    "inventory.label.ViewGoodsReceipt": "View Goods Receipt",
    "inventory.label.ViewItemDetail": "View Item Detail",
    "inventory.label.ItemDescription": "Item Description",
    "inventory.label.OrderedQuantity": "Ordered Quantity",
    "inventory.label.ReceivedQuantity": "Received Quantity",
    "inventory.label.AvailableActions": "Available Actions",
    "inventory.label.RequestedDate": "Requested Date",
    "inventory.label.RequestedBy": "Requested By",
    "inventory.label.RequestedFrom": "Requested From",
    "inventory.label.business_entity_name": "Business Entity Name",
    "inventory.label.Item Description": "Item Description",
    "inventory.label.Ordered Quantity": "Ordered Quantity",
    "inventory.label.Received Quantity": "Received Quantity",
    "inventory.label.Balance Quantity": "Balance Quantity",
    "inventory.label.status": "Status",
    "inventory.label.action": "Actions",
    "inventory.label.Create Goods Receipt": "Create Goods Receipt",
    "inventory.label.Purchase No": "Purchase No",
    "inventory.label.Supplier": "Supplier",
    "inventory.label.Office Id": "Office Id",
    "inventory.label.Item Code": "Item Code",
    "inventory.label.Ordered Quantity": "Ordered Quantity",
    "inventory.label.Edit Goods Receipt": "Edit Goods Receipt",
    "stockUpload.label.header": "Stock Upload",
    "stockUpload.label.Entity Name": "Entity Name",
    "stockUpload.label.Item Description": "Item Description",
    "stockUpload.label.Item Code": "Item Code",
    "stockUpload.label.AccountNumber": "Account Number",
    "stockUpload.label.Chip Id": "Chip Id",
    "stockUpload.label.Is Pairing": "Is Pairing",
    "stockUpload.label.Paired ItemId": "Paired ItemId",
    "stockUpload.label.Paired Item": "Paired Item",
    "stockUpload.label.Serial Number": "Serial Number",
    "stockUpload.label.Warranty Date": "Warranty Date",
    "stockUpload.label.Item Model": "Item Model",
    "stockTransfer.label.header": "Stock Transfer",
    "stockTransfer.label.Id": "Id",
    "stockTransfer.label.Requested Date": "Requested Date",
    "stockTransfer.label.Requested By": "Requested By",
    "stockTransfer.label.Request From": "Request From",
    "stockTransfer.label.Item Description": "Item Description",
    "stockTransfer.label.Ordered Quantity": "Ordered Quantity",
    "stockTransfer.label.Received Quantity": "Received Quantity",
    "stockTransfer.label.Create Item Sale": "Create Item Sale",
    "stockTransfer.label.Create MRN": "Create MRN",
    "stockTransfer.label.Create GRV": "Create GRV",
    "stockTransfer.label.Delete Item Sale": "Delete Item Sale",
    "stockTransfer.label.Are you sure?": "Are you sure?",
    "stockTransfer.label.Cancel": "CANCEL",
    "stockTransfer.label.Ok": "Ok",
    "stockUpload.label.add.Add Stock Upload": "Add Stock Upload",
    "stockUpload.label.add.Individual Load": "Individual Load",
    "stockUpload.label.add.Bulk Load": "Bulk Load",
    "stockUpload.label.add.GRN ID": "GRN ID",
    "stockUpload.label.add.itemDescription": "Item Description",
    "stockUpload.label.add.Suplier Code": "Supplier Code",
    "stockUpload.label.add.Received Quantity": "Received Quantity",
    "stockUpload.label.add.Entity Name": "Entity Name",
    "stockUpload.label.add.Ordered Quantity": "Ordered Quantity",
    "stockUpload.label.add.Quality": "Quality",
    "stockUpload.label.add.Item Model": "Item Model",
    "stockUpload.label.add.OEM Type": "OEM Type",
    "stockUpload.label.add.LM Type": "LM Type",
    "stockUpload.label.add.Serial No": "Serial No",
    "stockUpload.label.add.Provision No": "Provision No",
    "stockUpload.label.add.Paired Item": "Paired Item",
    "stockUpload.label.add.Is Paired": "Is Paired",
    "stockUpload.label.add.Remarks": "Remarks",
    "stockUpload.label.add.Carton No": "Carton No",
    "stockUpload.label.add.Select Name": "Select Name",
    "stockUpload.label.select_bulk_upload_type": "Bulk Upload Type",
    "stockUpload.label.add.Description": "Description",
    "stockUpload.label.add.Reset": "Reset",
    "stockUpload.label.add.Save": "Save",
    "stockUpload.label.add.Upload & Process": "Upload & Process",
    "stockUpload.label.add.Upload Process": "Upload Process",
    "stockUpload.label.add.Upload File Path": "Upload File Path",
    "stockUpload.label.add.Process Date": "Process Date",
    "stockUpload.label.add.Process/Total Records": "Process/Total Records",
    "Create StockUpload": "Create Stock Upload",
    "Edit Item Detail": "Edit Item Detail",
    "Provision Serial Number": "Provision Serial Number",
    "Serial Number": "Serial Number",
    "Track History": "Track History",
    "Ref Type": "Reference Type",
    "Transaction Date": "Transaction Date",
    Movement: "Movement",
    "From Office": "From Office",
    "To Office": "To Office",
    Done: "Done",
    Type: "Type",
    "Edit Item Sale": "Edit Item Sale",
    Item: "Item",
    "From ORG": "From Organization",
    "To ORG": "To Organization",
    Charge: "Charge",
    "Requested Quantity": "Requested Quantity",
    "Unit Price": "Unit Price",
    "Total Item Price": "Total Item Price",
    "Create Item Sale": "Create Item Sale",
    "Purchased From": "Purchased From",
    "Purchase By": "Purchase By",
    "Discount Type": "Discount Type",
    "Discount Rate": "Discount Rate",
    "Delete Item Model": "Delete Item Model",
    "View ItemSales": "View Item Sale",
    "Create MRN": "Create MRN",
    "View MRN": "View MRN",
    "Edit MRN": "Edit MRN",
    "Create GRV": "Create GRV",
    "View GRV": "View GRV",
    "Edit GRV": "Edit GRV",
    Notes: "Notes",
    "View Goods Receipt": "View Goods Receipt",
    "MRN Id": "MRN Id",
    "Cartoon Transfer": "Cartoon Transfer",
    "inventory.label.GoodsReceipt": "Goods Receipt",
    "inventory.label.StockUpload": "Stock Upload",
    "inventory.label.StockTransfer": "Stock Transfer",
    "inventory.label.ItemSale": "Item Sale",
    "inventory.label.MRN": "MRN",
    "inventory.label.GRV": "GRV",
    "inventory.label.Submit": "SUBMIT",
  },

  fr: {
    "inventory.label.EditGRV": "Modifier GRV",
    "inventory.label.Edit_MRN": "Modifier MRN",
    "inventory.label.CreateMRN": "Créer MRN",
    "inventory.label.DeleteItemDetail": "Supprimer le détail de l'article",
  "inventory.label.EditQuality": "Modifier la qualité",
  "inventory.label.Quality": "Qualité",
  "inventory.label.ViewTraker": "Voir le suivi",
  "inventory.label.EntityName": "Nom de l'entité",
  "inventory.label.ItemDescription": "Description de l'article",
  "inventory.label.ItemCode": "Code de l'article",
  "inventory.label.AccountNumber": "Numéro de compte",
  "inventory.label.ChipId": "ID de puce",
  "inventory.label.IsPairing": "Est jumelé",
  "inventory.label.PairedItemId": "ID de l'article jumelé",
  "inventory.label.PairedItem": "Article jumelé",
  "inventory.label.WarrantyDate": "Date de garantie",
  "inventory.label.ItemModel": "Modèle d'article",
  "inventory.label.status": "Statut",
  "inventory.label.EditItemDetail": "Modifier le détail de l'article",
  "inventory.label.CreateStockUpload": "Créer un chargement de stock",
  "inventory.label.SelectStatus": "Sélectionner un statut",
  "inventory.label.SelectDescription": "Sélectionner une description",
  "inventory.label.SelectBusinessEntity": "Sélectionner l'entité commerciale",
  "inventory.label.Warranty": "Garantie",
  "inventory.label.SupplierCode": "Code fournisseur",
  "inventory.label.GrnId": "ID GRN",
  "inventory.label.SerialNo": "Numéro de série",
  "inventory.label.ViewItemDetail": "Voir le détail de l'article",
  "inventory.label.Office": "Bureau",
    "inventory.label.RefType": "Type de référence",
  "inventory.label.TransactionDate": "Date de transaction",
  "inventory.label.Movement": "Mouvement",
  "inventory.label.FromOffice": "De bureau",
  "inventory.label.ToOffice": "À bureau",
  "inventory.label.TrackHistory": "Historique de suivi",
  "inventory.label.SerialNumber": "Numéro de série",
  "inventory.label.ProvisionSerialNumber": "Numéro de série de provision",
  "inventory.label.EditItemDetail": "Modifier les détails de l'article",
    "inventory.label.Download_Uploaded_File": "Télécharger le fichier téléchargé",
    "inventory.label.Download_Log_File": "Télécharger le fichier journal",
    "inventory.label.Description": "Description",
    "inventory.label.Browse_file_to_Upload": "Parcourir le fichier à télécharger",
    "inventory.label.Download_From_here": "Télécharger d'ici",
    "inventory.label.SelectItem": "Sélectionner l'élément",
    "inventory.label.SelectModel": "Sélectionner le modèle",
    "inventory.label.Browse_file_to_Upload": "Parcourir le fichier à télécharger",
    "inventory.label.Download_From_here": "Télécharger d'ici",
    "inventory.label.MRN_Id": "ID MRN",
    "inventory.label.Type": "Type",
    "inventory.label.CartoonTransfer": "Transfert de carton",
    "inventory.label.Are_you_sure_?": "Êtes-vous sûr ?",
  "inventory.label.Done": "Terminé",
  "inventory.label.RefType": "Type de référence",
  "inventory.label.Movement": "Mouvement",
  "inventory.label.TransactionDate": "Date de transaction",
  "inventory.label.ToOffice": "Au bureau",
  "inventory.label.FromOffice": "Du bureau",
  "inventory.label.TrackHistory": "Suivre l’historique",
  "inventory.label.SerialNumber": "Numéro de série",
  "inventory.label.ProvisionSerialNumber": "Numéro de série de provision",
  "inventory.label.SelectItem": "Sélectionner un article",
  "inventory.label.Quality": "Qualité",
  "inventory.label.EditItemDetail": "Modifier les détails de l’article",
  "inventory.label.Assets": "Actifs",
  "inventory.label.NoGenerator": "Pas de générateur",
  "inventory.label.Edit": "Modifier",
  "inventory.label.CreateStockUpload": "Créer un envoi de stock",
  "inventory.label.Delete": "Supprimer",
  "inventory.label.View": "Voir",
  "inventory.label.SelectStatus": "Sélectionner un statut",
  "inventory.label.SelectDescription": "Sélectionner une description",
  "inventory.label.SelectBusinessEntity": "Sélectionner une entité commerciale",
    "inventory.label.EditItemSale": "Modifier la vente d'article",
  "inventory.label.Item": "Article",
  "inventory.label.TotalItemPrice": "Prix total de l'article",
  "inventory.label.UnitPrice": "Prix unitaire",
  "inventory.label.RequestedQuantity": "Quantité demandée",
  "inventory.label.Charge": "Frais",
  "inventory.label.To_ORG": "À ORG",
  "inventory.label.ToOrganization": "À l'organisation",
  "inventory.label.FromOrganization": "De l'organisation",
  "inventory.label.From_ORG": "De ORG",
  "inventory.label.Type": "Type",
  "inventory.label.Notes": "Remarques",
    "inventory.label.SelectSearch": "Sélectionner la recherche",
  "inventory.label.CreateGRV": "Créer GRV",
  "inventory.label.Type": "Type",
  "inventory.label.Item": "Article",
  "inventory.label.Notes": "Remarques",
  "inventory.label.PurchasedFrom": "Acheté de",
  "inventory.label.PurchaseBy": "Acheté par",
  "inventory.label.Charge": "Frais",
  "inventory.label.TotalItemPrice?": "Prix total de l'article?",
  "inventory.label.DiscountType": "Type de remise",
  "inventory.label.DiscountRate": "Taux de remise",
  "inventory.label.UnitPrice": "Prix unitaire",
    "inventory.label.View_GRV": "Voir GRV",
  "inventory.label.Delete": "Supprimer",
  "inventory.label.DeleteItemModel": "Supprimer le modèle d'article",
  "inventory.label.View_MRN": "Voir MRN",
  "inventory.label.View_ItemSales": "Voir les ventes d'articles",
    "inventory.label.CreateNewContract": "Créer un nouveau contrat",
  "inventory.label.EditFeeMaster": "Modifier le maître des frais",
  "inventory.label.GRVId": "Identifiant GRV",
  "inventory.label.SerialNo": "Numéro de série",
  "inventory.label.MRNId": "Identifiant MRN",
  "inventory.label.SalesId": "Identifiant de vente",
  "inventory.label.Are_you_sure?": "Êtes-vous sûr ?",
  "inventory.label.DeleteItemSale": "Supprimer la vente d'article",
  "inventory.label.delete": "Supprimer",
  "inventory.label.MoveCarton": "Déplacer le carton",
  "inventory.label.MoveItems": "Déplacer les articles",
  "inventory.label.BulkStockTransfer": "Transfert de stock en masse",
  "inventory.label.Create_MRN/GRV": "Créer MRN/GRV",
  "inventory.label.CreateItemSale": "Créer une vente d'article",
    "entity.label.Edit": "Modifier",
  "entity.label.Delete": "Supprimer",
  "entity.label.DeleteItemModel": "Supprimer le modèle d'article",
  "entity.label.Item": "Article",
  "entity.label.DeleteItem": "Supprimer l'article",
    "inventory.label.DeleteItemDetails": "supprimera les détails de l'article",
    "inventory.label.header": "Réception des biens",
    "inventory.label.id": "Id",
    "inventory.label.Purchase Date": "Date d'achat",
    "inventory.label.Supplier Code": "Code fournisseur",
    "inventory.label.Entity Name": "Nom de l'entité",
    "inventory.label.Save": "Enregistrer",
    "inventory.label.Cancel": "Annuler",
    "inventory.label.Edit": "Modifier",
    "inventory.label.Ok": "Ok",
    "inventory.label.Reset": "Réinitialiser",
    "inventory.label.Update": "Mettre à jour",
    "inventory.label.PinNo": "Numéro de pin",
    "inventory.label.Delete": "Supprimer",
    "inventory.label.Value": "Valeur",
    "inventory.label.Confirm": "Confirmer",
    "inventory.label.PinType": "Type de pin",
    "inventory.label.CustomerId": "ID Client",
    "inventory.label.SerialNo": "Numéro de série",
    "inventory.label.OfficeId": "ID Bureau",
    "inventory.label.BatchName": "Nom du lot",
    "inventory.label.ManageVoucherPins": "Gérer les pins de bon",
    "inventory.label.ContractType": "Type de contrat",
    "inventory.label.ContractUnit": "Unité de contrat",
    "inventory.label.ViewGoodsReceipt": "Voir le reçu de marchandises",
    "inventory.label.ViewItemDetail": "Voir les détails de l'article",
    "inventory.label.ItemDescription": "Description de l'article",
    "inventory.label.OrderedQuantity": "Quantité commandée",
    "inventory.label.ReceivedQuantity": "Quantité reçue",
    "inventory.label.AvailableActions": "Actions disponibles",
    "inventory.label.RequestedDate": "Date de demande",
    "inventory.label.RequestedBy": "Demandé par",
    "inventory.label.RequestedFrom": "Demandé depuis",
    "inventory.label.business_entity_name": "Nom de l'Entité Commerciale",
    "inventory.label.Item Description": "Description de l'article",
    "inventory.label.Ordered Quantity": "Quantité commandée",
    "inventory.label.Received Quantity": "Quantité reçue",
    "inventory.label.Balance Quantity": "Quantité en stock",
    "inventory.label.status": "Statut",
    "inventory.label.action": "Action",
    "inventory.label.Create Goods Receipt": "Créer un reçu de marchandises",
    "inventory.label.Purchase No": "Numéro d'achat",
    "inventory.label.Supplier": "Fournisseur",
    "inventory.label.Office Id": "Identifiant du bureau",
    "inventory.label.Item Code": "Code d'article",
    "inventory.label.Ordered Quantity": "Quantité commandée",
    "inventory.label.Edit Goods Receipt": "Modifier le reçu de marchandises",
    "stockUpload.label.header": "  Chargement des stocks",
    "stockUpload.label.Entity Name": " Nom de l'entité",
    "stockUpload.label.Item Description": "Description de l'article ",
    "stockUpload.label.Item Code": " Code d'article",
    "stockUpload.label.AccountNumber": " Numéro de compte",
    "stockUpload.label.Chip Id": " Identifiant de puce",
    "stockUpload.label.Is Pairing": " Est en paire",
    "stockUpload.label.Paired ItemId": " Identifiant d'article apparié",
    "stockUpload.label.Paired Item": " Article apparié",
    "stockUpload.label.Serial Number": "Numéro de série ",
    "stockUpload.label.Warranty Date": " Date de garantie",
    "stockUpload.label.Item Model": " Modèle d'article",
    "stockTransfer.label.header": "Transfert de stock",
    "stockTransfer.label.Id": "Id",
    "stockTransfer.label.Requested Date": "Date demandée",
    "stockTransfer.label.Requested By": "Demandé par",
    "stockTransfer.label.Request From": "Demander de",
    "stockTransfer.label.Item Description": "Description de l'article",
    "stockTransfer.label.Ordered Quantity": "Quantité commandée",
    "stockTransfer.label.Received Quantity": "Quantité reçue",
    "stockTransfer.label.Create Item Sale": "Créer une vente d'article",
    "stockTransfer.label.Create MRN": "Créer MRN",
    "stockTransfer.label.Create GRV": "Créer GRV",
    "stockTransfer.label.Delete Item Sale": "Supprimer la vente d'article",
    "stockTransfer.label.Are you sure?": "Êtes-vous sûr ?",
    "stockTransfer.label.Cancel": "Annuler",
    "stockTransfer.label.Ok": "Ok",
    "stockUpload.label.add.Add Stock Upload":
      "Ajouter le téléchargement de stock",
    "stockUpload.label.add.Individual Load": "Chargement individuel",
    "stockUpload.label.add.Bulk Load": "Chargement en vrac",
    "stockUpload.label.add.GRN ID": "ID de RCR",
    "stockUpload.label.add.itemDescription": "Description de l'article",
    "stockUpload.label.add.Suplier Code": "Code fournisseur",
    "stockUpload.label.add.Received Quantity": "Quantité reçue",
    "stockUpload.label.add.Entity Name": "Nom de l'entité",
    "stockUpload.label.add.Ordered Quantity": "Quantité commandée",
    "stockUpload.label.add.Quality": "Qualité",
    "stockUpload.label.add.Item Model": "Modèle de l'article",
    "stockUpload.label.add.OEM Type": "Type OEM",
    "stockUpload.label.add.LM Type": "Type de LM",
    "stockUpload.label.add.Serial No": "Numéro de série",
    "stockUpload.label.add.Provision No": "Numéro de provision",
    "stockUpload.label.add.Paired Item": "Article apparié",
    "stockUpload.label.add.Is Paired": "Est apparié",
    "stockUpload.label.add.Remarks": "Remarques",
    "stockUpload.label.add.Carton No": "Numéro de carton",
    "stockUpload.label.add.Select Name": "Sélectionner le nom",
    "stockUpload.label.select_bulk_upload_type":
      "Sélectionner le Type de Téléchargement en Masse",
    "stockUpload.label.add.Description": "Description",
    "stockUpload.label.add.Reset": "Réinitialiser",
    "stockUpload.label.add.Save": "Enregistrer",
    "stockUpload.label.add.Upload & Process": "Télécharger et traiter",
    "stockUpload.label.add.Upload Process": "Processus de téléchargement",
    "stockUpload.label.add.Upload File Path":
      "Chemin du fichier de téléchargement",
    "stockUpload.label.add.Process Date": "Date de traitement",
    "stockUpload.label.add.Process/Total Records":
      "Enregistrements de processus/total",
    "Create StockUpload": "Créer un téléchargement de stock",
    "Edit Item Detail": "Modifier les détails de l'article",
    "Provision Serial Number": "Numéro de série de provision",
    "Serial Number": "Numéro de série",
    "Track History": "Historique de suivi",
    "Ref Type": "Type de référence",
    "Transaction Date": "Date de transaction",
    Movement: "Mouvement",
    "From Office": "Du bureau",
    "To Office": "Au bureau",
    Done: "Terminé",
    Type: "Type",
    "Edit Item Sale": "Modifier la vente d'articles",
    Item: "Article",
    "From ORG": "De l'organisation",
    "To ORG": "À l'organisation",
    Charge: "Frais",
    "Requested Quantity": "Quantité demandée",
    "Unit Price": "Prix unitaire",
    "Total Item Price": "Prix total de l'article",
    "Create Item Sale": "Créer une vente d'articles",
    "Purchased From": "Acheté de",
    "Purchase By": "Acheté par",
    "Discount Type": "Type de réduction",
    "Discount Rate": "Taux de réduction",
    "Delete Item Model": "Supprimer le modèle d'article",
    "View ItemSales": "Voir la vente de l'article",
    "Create MRN": "Créer un MRN",
    "View MRN": "Voir le MRN",
    "Edit MRN": "Modifier le MRN",
    "Create GRV": "Créer un GRV",
    "View GRV": "Voir le GRV",
    "Edit GRV": "Modifier le GRV",
    Notes: "Notes",
    "View Goods Receipt": "Voir le bon de réception",
    "MRN Id": "Identifiant MRN",
    "Cartoon Transfer": "Transfert de dessin animé",
    "inventory.label.GoodsReceipt": "La réception des marchandises",
    "inventory.label.StockUpload": "Téléchargement de Stock",
    "inventory.label.StockTransfer": "Transfert de Stock",
    "inventory.label.ItemSale": "Vente d'Article",
    "inventory.label.MRN": "MRN",
    "inventory.label.GRV": "GRV",
    "inventory.label.Submit": "Soumettre",
  },

  es: {
    "inventory.label.EditGRV": "Editar GRV",
    "inventory.label.Edit_MRN": "Editar MRN",
    "inventory.label.CreateMRN": "Crear MRN",
    "inventory.label.DeleteItemDetail": "Eliminar detalle del artículo",
  "inventory.label.EditQuality": "Editar calidad",
  "inventory.label.Quality": "Calidad",
  "inventory.label.ViewTraker": "Ver rastreador",
  "inventory.label.EntityName": "Nombre de la entidad",
  "inventory.label.ItemDescription": "Descripción del artículo",
  "inventory.label.ItemCode": "Código del artículo",
  "inventory.label.AccountNumber": "Número de cuenta",
  "inventory.label.ChipId": "ID del chip",
  "inventory.label.IsPairing": "¿Emparejado?",
  "inventory.label.PairedItemId": "ID del artículo emparejado",
  "inventory.label.PairedItem": "Artículo emparejado",
  "inventory.label.WarrantyDate": "Fecha de garantía",
  "inventory.label.ItemModel": "Modelo del artículo",
  "inventory.label.status": "Estado",
  "inventory.label.EditItemDetail": "Editar detalle del artículo",
  "inventory.label.CreateStockUpload": "Crear carga de stock",
  "inventory.label.SelectStatus": "Seleccionar estado",
  "inventory.label.SelectDescription": "Seleccionar descripción",
  "inventory.label.SelectBusinessEntity": "Seleccionar entidad comercial",
  "inventory.label.Warranty": "Garantía",
  "inventory.label.SupplierCode": "Código del proveedor",
  "inventory.label.GrnId": "ID GRN",
  "inventory.label.SerialNo": "Número de serie",
  "inventory.label.ViewItemDetail": "Ver detalle del artículo",
  "inventory.label.Office": "Oficina",
    "inventory.label.RefType": "Tipo de referencia",
  "inventory.label.TransactionDate": "Fecha de transacción",
  "inventory.label.Movement": "Movimiento",
  "inventory.label.FromOffice": "Desde oficina",
  "inventory.label.ToOffice": "A oficina",
  "inventory.label.TrackHistory": "Rastrear historial",
  "inventory.label.SerialNumber": "Número de serie",
  "inventory.label.ProvisionSerialNumber": "Número de serie de provisión",
  "inventory.label.EditItemDetail": "Editar detalle del artículo",
    "inventory.label.Download_Uploaded_File": "Descargar archivo subido",
    "inventory.label.Download_Log_File": "Descargar archivo de registro",
    "inventory.label.Description": "Descripción",
    "inventory.label.Browse_file_to_Upload": "Examinar archivo para cargar",
    "inventory.label.Download_From_here": "Descargar desde aquí",
    "inventory.label.SelectItem": "Seleccionar artículo",
    "inventory.label.SelectModel": "Seleccionar modelo",
    "inventory.label.Browse_file_to_Upload": "Examinar archivo para cargar",
    "inventory.label.Download_From_here": "Descargar desde aquí",
    "inventory.label.MRN_Id": "ID MRN",
    "inventory.label.Type": "Tipo",
    "inventory.label.CartoonTransfer": "Transferencia de cartón",
    "inventory.label.Are_you_sure_?": "¿Estás seguro?",
  "inventory.label.Done": "Hecho",
  "inventory.label.RefType": "Tipo de referencia",
  "inventory.label.Movement": "Movimiento",
  "inventory.label.TransactionDate": "Fecha de transacción",
  "inventory.label.ToOffice": "A la oficina",
  "inventory.label.FromOffice": "Desde la oficina",
  "inventory.label.TrackHistory": "Rastrear historial",
  "inventory.label.SerialNumber": "Número de serie",
  "inventory.label.ProvisionSerialNumber": "Número de serie de provisión",
  "inventory.label.SelectItem": "Seleccionar artículo",
  "inventory.label.Quality": "Calidad",
  "inventory.label.EditItemDetail": "Editar detalles del artículo",
  "inventory.label.Assets": "Activos",
  "inventory.label.NoGenerator": "Sin generador",
  "inventory.label.Edit": "Editar",
  "inventory.label.CreateStockUpload": "Crear carga de stock",
  "inventory.label.Delete": "Eliminar",
  "inventory.label.View": "Ver",
  "inventory.label.SelectStatus": "Seleccionar estado",
  "inventory.label.SelectDescription": "Seleccionar descripción",
  "inventory.label.SelectBusinessEntity": "Seleccionar entidad comercial",
    "inventory.label.EditItemSale": "Editar venta de artículo",
  "inventory.label.Item": "Artículo",
  "inventory.label.TotalItemPrice": "Precio total del artículo",
  "inventory.label.UnitPrice": "Precio unitario",
  "inventory.label.RequestedQuantity": "Cantidad solicitada",
  "inventory.label.Charge": "Cargo",
  "inventory.label.To_ORG": "A ORG",
  "inventory.label.ToOrganization": "A la organización",
  "inventory.label.FromOrganization": "De la organización",
  "inventory.label.From_ORG": "De ORG",
  "inventory.label.Type": "Tipo",
  "inventory.label.Notes": "Notas",
    "inventory.label.SelectSearch": "Seleccionar búsqueda",
  "inventory.label.CreateGRV": "Crear GRV",
  "inventory.label.Type": "Tipo",
  "inventory.label.Item": "Artículo",
  "inventory.label.Notes": "Notas",
  "inventory.label.PurchasedFrom": "Comprado de",
  "inventory.label.PurchaseBy": "Comprado por",
  "inventory.label.Charge": "Cargo",
  "inventory.label.TotalItemPrice?": "¿Precio total del artículo?",
  "inventory.label.DiscountType": "Tipo de descuento",
  "inventory.label.DiscountRate": "Tasa de descuento",
  "inventory.label.UnitPrice": "Precio unitario",

  "inventory.label.View_GRV": "Ver GRV",
  "inventory.label.Delete": "Eliminar",
  "inventory.label.DeleteItemModel": "Eliminar modelo de artículo",
  "inventory.label.View_MRN": "Ver MRN",
  "inventory.label.View_ItemSales": "Ver ventas de artículos",
    "inventory.label.CreateNewContract": "Crear nuevo contrato",
  "inventory.label.EditFeeMaster": "Editar tarifa maestra",
  "inventory.label.GRVId": "ID de GRV",
  "inventory.label.SerialNo": "Número de serie",
  "inventory.label.MRNId": "ID de MRN",
  "inventory.label.SalesId": "ID de venta",
  "inventory.label.Are_you_sure?": "¿Estás seguro?",
  "inventory.label.DeleteItemSale": "Eliminar venta de artículo",
  "inventory.label.delete": "Eliminar",
  "inventory.label.MoveCarton": "Mover caja",
  "inventory.label.MoveItems": "Mover artículos",
  "inventory.label.BulkStockTransfer": "Transferencia masiva de stock",
  "inventory.label.Create_MRN/GRV": "Crear MRN/GRV",
  "inventory.label.CreateItemSale": "Crear venta de artículo",
    "entity.label.Edit": "Editar",
  "entity.label.Delete": "Eliminar",
  "entity.label.DeleteItemModel": "Eliminar modelo de artículo",
  "entity.label.Item": "Artículo",
  "entity.label.DeleteItem": "Eliminar artículo",
    "inventory.label.DeleteItemDetails": "Eliminar detalles del artículo",
    "inventory.label.header": "Recibo de mercancías",
    "inventory.label.id": "Id",
    "inventory.label.Purchase Date": "Fecha de compra",
    "inventory.label.Supplier Code": "Código de proveedor",
    "inventory.label.Entity Name": "Nombre de la entidad",
    "inventory.label.Save": "Guardar",
    "inventory.label.Cancel": "Cancelar",
    "inventory.label.Edit": "Editar",
    "inventory.label.Ok": "Aceptar",
    "inventory.label.Reset": "Restablecer",
    "inventory.label.Update": "Actualizar",
    "inventory.label.PinNo": "Número de PIN",
    "inventory.label.Delete": "Eliminar",
    "inventory.label.Value": "Valor",
    "inventory.label.Confirm": "Confirmar",
    "inventory.label.PinType": "Tipo de PIN",
    "inventory.label.CustomerId": "ID del Cliente",
    "inventory.label.SerialNo": "Número de Serie",
    "inventory.label.OfficeId": "ID de Oficina",
    "inventory.label.BatchName": "Nombre del Lote",
    "inventory.label.ManageVoucherPins": "Gestionar Pines de Vale",
    "inventory.label.ContractType": "Tipo de Contrato",
    "inventory.label.ContractUnit": "Unidad de Contrato",
    "inventory.label.ViewGoodsReceipt": "Ver Recibo de Mercancías",
    "inventory.label.ViewItemDetail": "Ver Detalles del Artículo",
    "inventory.label.ItemDescription": "Descripción del Artículo",
    "inventory.label.OrderedQuantity": "Cantidad Pedida",
    "inventory.label.ReceivedQuantity": "Cantidad Recibida",
    "inventory.label.AvailableActions": "Acciones Disponibles",
    "inventory.label.RequestedDate": "Fecha Solicitada",
    "inventory.label.RequestedBy": "Solicitado Por",
    "inventory.label.RequestedFrom": "Solicitado Desde",
    "inventory.label.business_entity_name": "Nombre de la Entidad Comercial",
    "inventory.label.Item Description": "Descripción del artículo",
    "inventory.label.Ordered Quantity": "Cantidad ordenada",
    "inventory.label.Received Quantity": "Cantidad recibida",
    "inventory.label.Balance Quantity": "Cantidad en balance",
    "inventory.label.status": "Estado",
    "inventory.label.action": "Acción",
    "inventory.label.Create Goods Receipt": "Crear recibo de mercancía",
    "inventory.label.Purchase No": "Número de compra",
    "inventory.label.Supplier": "Proveedor",
    "inventory.label.Office Id": "Identificación de la oficina",
    "inventory.label.Item Code": "Código de artículo",
    "inventory.label.Ordered Quantity": "Cantidad ordenada",
    "inventory.label.Edit Goods Receipt": "Editar recibo de mercancía",
    "stockUpload.label.header": " Carga de stock",
    "stockUpload.label.Entity Name": " Nombre de entidad",
    "stockUpload.label.Item Description": "Descripción del artículo ",
    "stockUpload.label.Item Code": " Código de artículo",
    "stockUpload.label.AccountNumber": " Número de cuenta",
    "stockUpload.label.Chip Id": " ID de chip",
    "stockUpload.label.Is Pairing": " ¿Está emparejado?",
    "stockUpload.label.Paired ItemId": " ID de artículo emparejado",
    "stockUpload.label.Paired Item": " Artículo emparejado",
    "stockUpload.label.Serial Number": " Número de serie",
    "stockUpload.label.Warranty Date": " Fecha de garantía",
    "stockUpload.label.Item Model": " Modelo de artículo",
    "stockTransfer.label.header": "Transferencia de stock",
    "stockTransfer.label.Id": "Id",
    "stockTransfer.label.Requested Date": "Fecha solicitada",
    "stockTransfer.label.Requested By": "Solicitado por",
    "stockTransfer.label.Request From": "Solicitar desde",
    "stockTransfer.label.Item Description": "Descripción del artículo",
    "stockTransfer.label.Ordered Quantity": "Cantidad ordenada",
    "stockTransfer.label.Received Quantity": "Cantidad recibida",
    "stockTransfer.label.Create Item Sale": "Crear venta de artículo",
    "stockTransfer.label.Create MRN": "Crear MRN",
    "stockTransfer.label.Create GRV": "Crear GRV",
    "stockTransfer.label.Delete Item Sale": "Eliminar venta de artículo",
    "stockTransfer.label.Are you sure?": "¿Estás seguro?",
    "stockTransfer.label.Cancel": "Cancelar",
    "stockTransfer.label.Ok": "Ok",
    "stockUpload.label.add.Add Stock Upload": "Agregar carga de stock",
    "stockUpload.label.add.Individual Load": "Carga individual",
    "stockUpload.label.add.Bulk Load": "Carga a granel",
    "stockUpload.label.add.GRN ID": "ID de RNC",
    "stockUpload.label.add.itemDescription": "Descripción del artículo",
    "stockUpload.label.add.Suplier Code": "Código de proveedor",
    "stockUpload.label.add.Received Quantity": "Cantidad recibida",
    "stockUpload.label.add.Entity Name": "Nombre de la entidad",
    "stockUpload.label.add.Ordered Quantity": "Cantidad ordenada",
    "stockUpload.label.add.Quality": "Calidad",
    "stockUpload.label.add.Item Model": "Modelo del artículo",
    "stockUpload.label.add.OEM Type": "Tipo OEM",
    "stockUpload.label.add.LM Type": "Tipo LM",
    "stockUpload.label.add.Serial No": "Número de serie",
    "stockUpload.label.add.Provision No": "Número de provisión",
    "stockUpload.label.add.Paired Item": "Artículo emparejado",
    "stockUpload.label.add.Is Paired": "Está emparejado",
    "stockUpload.label.add.Remarks": "Observaciones",
    "stockUpload.label.add.Carton No": "Número de cartón",
    "stockUpload.label.add.Select Name": "Seleccionar nombre",
    "stockUpload.label.select_bulk_upload_type":
      "Seleccionar Tipo de Carga Masiva",
    "stockUpload.label.add.Description": "Descripción",
    "stockUpload.label.add.Reset": "Reiniciar",
    "stockUpload.label.add.Save": "Guardar",
    "stockUpload.label.add.Upload & Process": "Cargar y procesar",
    "stockUpload.label.add.Upload Process": "Proceso de carga",
    "stockUpload.label.add.Upload File Path": "Ruta del archivo de carga",
    "stockUpload.label.add.Process Date": "Fecha de proceso",
    "stockUpload.label.add.Process/Total Records": "Registros de proceso/total",
    "Create StockUpload": "Crear carga de stock",
    "Edit Item Detail": "Editar Detalle del Artículo",
    "Provision Serial Number": "Número de Serie de Provisión",
    "Serial Number": "Número de Serie",
    "Track History": "Historial de Seguimiento",
    "Ref Type": "Tipo de Referencia",
    "Transaction Date": "Fecha de Transacción",
    Movement: "Movimiento",
    "From Office": "Desde Oficina",
    "To Office": "Hacia Oficina",
    Done: "Hecho",
    Type: "Tipo",
    "Edit Item Sale": "Editar Venta de Artículo",
    Item: "Artículo",
    "From ORG": "Desde Organización",
    "To ORG": "Para Organización",
    Charge: "Cargo",
    "Requested Quantity": "Cantidad Solicitada",
    "Unit Price": "Precio Unitario",
    "Total Item Price": "Precio Total del Artículo",
    "Create Item Sale": "Crear Venta de Artículo",
    "Purchased From": "Comprado De",
    "Purchase By": "Comprado Por",
    "Discount Type": "Tipo de Descuento",
    "Discount Rate": "Tasa de Descuento",
    "Delete Item Model": "Eliminar Modelo de Artículo",
    "View ItemSales": "Ver venta del artículo",
    "Create MRN": "Crear MRN",
    "View MRN": "Ver MRN",
    "Edit MRN": "Editar MRN",
    "Create GRV": "Crear GRV",
    "View GRV": "Ver GRV",
    "Edit GRV": "Editar GRV",
    Notes: "Notas",
    "View Goods Receipt": "Ver Recibo de Mercancías",
    "MRN Id": "Identificación de MRN",
    "Cartoon Transfer": "Transferencia de Dibujos Animados",
    "inventory.label.GoodsReceipt": "Entrada de mercancías",
    "inventory.label.StockUpload": "Carga de Inventario",
    "inventory.label.StockTransfer": "Transferencia de Stock",
    "inventory.label.ItemSale": "Venta de Artículo",
    "inventory.label.MRN": "MRN",
    "inventory.label.GRV": "GRV",
    "inventory.label.Submit": "Enviar",
  },

  pt: {
    "inventory.label.EditGRV": "Editar GRV",
    "inventory.label.Edit_MRN": "Editar MRN",
    "inventory.label.CreateMRN": "Criar MRN",
    "inventory.label.DeleteItemDetail": "Excluir detalhe do item",
  "inventory.label.EditQuality": "Editar qualidade",
  "inventory.label.Quality": "Qualidade",
  "inventory.label.ViewTraker": "Visualizar rastreador",
  "inventory.label.EntityName": "Nome da entidade",
  "inventory.label.ItemDescription": "Descrição do item",
  "inventory.label.ItemCode": "Código do item",
  "inventory.label.AccountNumber": "Número da conta",
  "inventory.label.ChipId": "ID do chip",
  "inventory.label.IsPairing": "Está emparelhado",
  "inventory.label.PairedItemId": "ID do item emparelhado",
  "inventory.label.PairedItem": "Item emparelhado",
  "inventory.label.WarrantyDate": "Data da garantia",
  "inventory.label.ItemModel": "Modelo do item",
  "inventory.label.status": "Status",
  "inventory.label.EditItemDetail": "Editar detalhe do item",
  "inventory.label.CreateStockUpload": "Criar envio de estoque",
  "inventory.label.SelectStatus": "Selecionar status",
  "inventory.label.SelectDescription": "Selecionar descrição",
  "inventory.label.SelectBusinessEntity": "Selecionar entidade empresarial",
  "inventory.label.Warranty": "Garantia",
  "inventory.label.SupplierCode": "Código do fornecedor",
  "inventory.label.GrnId": "ID GRN",
  "inventory.label.SerialNo": "Número de série",
  "inventory.label.ViewItemDetail": "Visualizar detalhe do item",
  "inventory.label.Office": "Escritório",
    "inventory.label.RefType": "Tipo de referência",
  "inventory.label.TransactionDate": "Data da transação",
  "inventory.label.Movement": "Movimentação",
  "inventory.label.FromOffice": "Do escritório",
  "inventory.label.ToOffice": "Para o escritório",
  "inventory.label.TrackHistory": "Rastrear histórico",
  "inventory.label.SerialNumber": "Número de série",
  "inventory.label.ProvisionSerialNumber": "Número de série de provisão",
  "inventory.label.EditItemDetail": "Editar detalhe do item",
    "inventory.label.Download_Uploaded_File": "Baixar arquivo carregado",
    "inventory.label.Download_Log_File": "Baixar arquivo de log",
    "inventory.label.Description": "Descrição",
    "inventory.label.Browse_file_to_Upload": "Procurar arquivo para enviar",
    "inventory.label.Download_From_here": "Baixar daqui",
    "inventory.label.SelectItem": "Selecionar item",
    "inventory.label.SelectModel": "Selecionar modelo",
    "inventory.label.Browse_file_to_Upload": "Procurar arquivo para enviar",
    "inventory.label.Download_From_here": "Baixar daqui",
    "inventory.label.MRN_Id": "ID MRN",
    "inventory.label.Type": "Tipo",
    "inventory.label.CartoonTransfer": "Transferência de Cartoon",
    "inventory.label.Are_you_sure_?": "Tem certeza?",
  "inventory.label.Done": "Concluído",
  "inventory.label.RefType": "Tipo de referência",
  "inventory.label.Movement": "Movimento",
  "inventory.label.TransactionDate": "Data da transação",
  "inventory.label.ToOffice": "Para o escritório",
  "inventory.label.FromOffice": "Do escritório",
  "inventory.label.TrackHistory": "Rastrear histórico",
  "inventory.label.SerialNumber": "Número de série",
  "inventory.label.ProvisionSerialNumber": "Número de série da provisão",
  "inventory.label.SelectItem": "Selecionar item",
  "inventory.label.Quality": "Qualidade",
  "inventory.label.EditItemDetail": "Editar detalhes do item",
  "inventory.label.Assets": "Ativos",
  "inventory.label.NoGenerator": "Sem gerador",
  "inventory.label.Edit": "Editar",
  "inventory.label.CreateStockUpload": "Criar envio de estoque",
  "inventory.label.Delete": "Excluir",
  "inventory.label.View": "Visualizar",
  "inventory.label.SelectStatus": "Selecionar status",
  "inventory.label.SelectDescription": "Selecionar descrição",
  "inventory.label.SelectBusinessEntity": "Selecionar entidade comercial",
    "inventory.label.EditItemSale": "Editar venda de item",
  "inventory.label.Item": "Item",
  "inventory.label.TotalItemPrice": "Preço total do item",
  "inventory.label.UnitPrice": "Preço unitário",
  "inventory.label.RequestedQuantity": "Quantidade solicitada",
  "inventory.label.Charge": "Cobrança",
  "inventory.label.To_ORG": "Para ORG",
  "inventory.label.ToOrganization": "Para organização",
  "inventory.label.FromOrganization": "De organização",
  "inventory.label.From_ORG": "De ORG",
  "inventory.label.Type": "Tipo",
  "inventory.label.Notes": "Notas",
    "inventory.label.SelectSearch": "Selecionar pesquisa",
  "inventory.label.CreateGRV": "Criar GRV",
  "inventory.label.Type": "Tipo",
  "inventory.label.Item": "Item",
  "inventory.label.Notes": "Notas",
  "inventory.label.PurchasedFrom": "Comprado de",
  "inventory.label.PurchaseBy": "Comprado por",
  "inventory.label.Charge": "Cobrança",
  "inventory.label.TotalItemPrice?": "Preço total do item?",
  "inventory.label.DiscountType": "Tipo de desconto",
  "inventory.label.DiscountRate": "Taxa de desconto",
  "inventory.label.UnitPrice": "Preço unitário",
  "inventory.label.View_GRV": "Visualizar GRV",
  "inventory.label.Delete": "Excluir",
  "inventory.label.DeleteItemModel": "Excluir modelo de item",
  "inventory.label.View_MRN": "Visualizar MRN",
  "inventory.label.View_ItemSales": "Visualizar vendas de itens",
    "inventory.label.CreateNewContract": "Criar novo contrato",
  "inventory.label.EditFeeMaster": "Editar mestre de taxas",
  "inventory.label.GRVId": "ID do GRV",
  "inventory.label.SerialNo": "Número de série",
  "inventory.label.MRNId": "ID do MRN",
  "inventory.label.SalesId": "ID de venda",
  "inventory.label.Are_you_sure?": "Tem certeza?",
  "inventory.label.DeleteItemSale": "Excluir venda do item",
  "inventory.label.delete": "Excluir",
  "inventory.label.MoveCarton": "Mover caixa",
  "inventory.label.MoveItems": "Mover itens",
  "inventory.label.BulkStockTransfer": "Transferência em massa de estoque",
  "inventory.label.Create_MRN/GRV": "Criar MRN/GRV",
  "inventory.label.CreateItemSale": "Criar venda de item",
    "entity.label.Edit": "Editar",
  "entity.label.Delete": "Excluir",
  "entity.label.DeleteItemModel": "Excluir modelo de item",
  "entity.label.Item": "Item",
  "entity.label.DeleteItem": "Excluir item",
    "inventory.label.DeleteItemDetails": "Excluir detalhes do item",
    "inventory.label.header": "Recebimento de mercadorias",
    "inventory.label.id": "Id",
    "inventory.label.Purchase Date": "Data de compra",
    "inventory.label.Supplier Code": "Código do fornecedor",
    "inventory.label.Entity Name": "Nome da entidade",
    "inventory.label.Save": "Salvar",
    "inventory.label.Cancel": "Cancelar",
    "inventory.label.Edit": "Editar",
    "inventory.label.Ok": "Ok",
    "inventory.label.Reset": "Redefinir",
    "inventory.label.Update": "Atualizar",
    "inventory.label.PinNo": "Número do PIN",
    "inventory.label.Delete": "Excluir",
    "inventory.label.Value": "Valor",
    "inventory.label.Confirm": "Confirmar",
    "inventory.label.PinType": "Tipo de PIN",
    "inventory.label.CustomerId": "ID do Cliente",
    "inventory.label.SerialNo": "Número de Série",
    "inventory.label.OfficeId": "ID do Escritório",
    "inventory.label.BatchName": "Nome do Lote",
    "inventory.label.ManageVoucherPins": "Gerenciar PINs de Vale",
    "inventory.label.ContractType": "Tipo de Contrato",
    "inventory.label.ContractUnit": "Unidade de Contrato",
    "inventory.label.ViewGoodsReceipt": "Visualizar Recibo de Mercadorias",
    "inventory.label.ViewItemDetail": "Visualizar Detalhes do Item",
    "inventory.label.ItemDescription": "Descrição do Item",
    "inventory.label.OrderedQuantity": "Quantidade Pedida",
    "inventory.label.ReceivedQuantity": "Quantidade Recebida",
    "inventory.label.AvailableActions": "Ações Disponíveis",
    "inventory.label.RequestedDate": "Data Solicitada",
    "inventory.label.RequestedBy": "Solicitado Por",
    "inventory.label.RequestedFrom": "Solicitado De",
    "inventory.label.business_entity_name": "Nome da Entidade Empresarial",
    "inventory.label.Item Description": "Descrição do item",
    "inventory.label.Ordered Quantity": "Quantidade encomendada",
    "inventory.label.Received Quantity": "Quantidade recebida",
    "inventory.label.Balance Quantity": "Quantidade em saldo",
    "inventory.label.status": "Estado",
    "inventory.label.action": "Ação",
    "inventory.label.Create Goods Receipt": "Criar recibo de mercadorias",
    "inventory.label.Purchase No": "Número de compra",
    "inventory.label.Supplier": "Fornecedor",
    "inventory.label.Office Id": "Identificação do escritório",
    "inventory.label.Item Code": "Código do item",
    "inventory.label.Ordered Quantity": "Quantidade encomendada",
    "inventory.label.Edit Goods Receipt": "Editar recibo de mercadorias",
    "stockUpload.label.header": " Carregar estoque",
    "stockUpload.label.Entity Name": " Nome da entidade",
    "stockUpload.label.Item Description": " Descrição do item",
    "stockUpload.label.Item Code": " Código do item",
    "stockUpload.label.AccountNumber": " Número da conta",
    "stockUpload.label.Chip Id": " ID do chip",
    "stockUpload.label.Is Pairing": " Está emparelhado",
    "stockUpload.label.Paired ItemId": " ID do item emparelhado",
    "stockUpload.label.Paired Item": " Item emparelhado",
    "stockUpload.label.Serial Number": " Número de série",
    "stockUpload.label.Warranty Date": "Data de garantia ",
    "stockUpload.label.Item Model": "Modelo do item ",
    "stockTransfer.label.header": "Transferência de estoque",
    "stockTransfer.label.Id": "Id",
    "stockTransfer.label.Requested Date": "Data solicitada",
    "stockTransfer.label.Requested By": "Solicitado por",
    "stockTransfer.label.Request From": "Solicitar De",
    "stockTransfer.label.Item Description": "Descrição do item",
    "stockTransfer.label.Ordered Quantity": "Quantidade encomendada",
    "stockTransfer.label.Received Quantity": "Quantidade recebida",
    "stockTransfer.label.Create Item Sale": "Criar venda de item",
    "stockTransfer.label.Create MRN": "Criar MRN",
    "stockTransfer.label.Create GRV": "Criar GRV",
    "stockTransfer.label.Delete Item Sale": "Excluir venda de item",
    "stockTransfer.label.Are you sure?": "Tem certeza?",
    "stockTransfer.label.Cancel": "Cancelar",
    "stockTransfer.label.Ok": "Ok",
    "stockUpload.label.add.Add Stock Upload": "Adicionar carga de estoque",
    "stockUpload.label.add.Individual Load": "Carga individual",
    "stockUpload.label.add.Bulk Load": "Carga em massa",
    "stockUpload.label.add.GRN ID": "ID de RNC",
    "stockUpload.label.add.itemDescription": "Descrição do item",
    "stockUpload.label.add.Suplier Code": "Código do fornecedor",
    "stockUpload.label.add.Received Quantity": "Quantidade recebida",
    "stockUpload.label.add.Entity Name": "Nome da entidade",
    "stockUpload.label.add.Ordered Quantity": "Quantidade ordenada",
    "stockUpload.label.add.Quality": "Qualidade",
    "stockUpload.label.add.Item Model": "Modelo do item",
    "stockUpload.label.add.OEM Type": "Tipo OEM",
    "stockUpload.label.add.LM Type": "Tipo LM",
    "stockUpload.label.add.Serial No": "Número de série",
    "stockUpload.label.add.Provision No": "Número de provisão",
    "stockUpload.label.add.Paired Item": "Item emparelhado",
    "stockUpload.label.add.Is Paired": "Está emparelhado",
    "stockUpload.label.add.Remarks": "Observações",
    "stockUpload.label.add.Carton No": "Número da caixa",
    "stockUpload.label.add.Select Name": "Selecionar nome",
    "stockUpload.label.select_bulk_upload_type":
      "Selecionar Tipo de Upload em Massa",
    "stockUpload.label.add.Description": "Descrição",
    "stockUpload.label.add.Reset": "Redefinir",
    "stockUpload.label.add.Save": "Salvar",
    "stockUpload.label.add.Upload & Process": "Carregar e processar",
    "stockUpload.label.add.Upload Process": "Processo de carregamento",
    "stockUpload.label.add.Upload File Path": "Caminho do arquivo de upload",
    "stockUpload.label.add.Process Date": "Data de processamento",
    "stockUpload.label.add.Process/Total Records":
      "Registros de processo/total",
    "Create StockUpload": "Criar Carregamento de Estoque",
    "Edit Item Detail": "Editar Detalhes do Item",
    "Provision Serial Number": "Número de Série de Provisão",
    "Serial Number": "Número de Série",
    "Track History": "Histórico de Rastreamento",
    "Ref Type": "Tipo de Referência",
    "Transaction Date": "Data da Transação",
    Movement: "Movimento",
    "From Office": "Do Escritório",
    "To Office": "Para o Escritório",
    Done: "Concluído",
    Type: "Tipo",
    "Edit Item Sale": "Editar Venda do Item",
    Item: "Item",
    "From ORG": "Da Organização",
    "To ORG": "Para a Organização",
    Charge: "Carga",
    "Requested Quantity": "Quantidade Solicitada",
    "Unit Price": "Preço Unitário",
    "Total Item Price": "Preço Total do Item",
    "Create Item Sale": "Criar Venda do Item",
    "Purchased From": "Comprado De",
    "Purchase By": "Comprado Por",
    "Discount Type": "Tipo de Desconto",
    "Discount Rate": "Taxa de Desconto",
    "Delete Item Model": "Excluir Modelo de Item",
    "View ItemSales": "Ver venda do item",
    "Create MRN": "Criar MRN",
    "View MRN": "Ver MRN",
    "Edit MRN": "Editar MRN",
    "Create GRV": "Criar GRV",
    "View GRV": "Ver GRV",
    "Edit GRV": "Editar GRV",
    Notes: "Notas",
    "View Goods Receipt": "Ver Recebimento de Mercadorias",
    "MRN Id": "ID do MRN",
    "Cartoon Transfer": "Transferência de Desenhos Animados",
    "inventory.label.GoodsReceipt": "Entrada de mercadorias",
    "inventory.label.StockUpload": "Upload de Estoque",
    "inventory.label.StockTransfer": "Transferência de Estoque",
    "inventory.label.ItemSale": "Venda de Item",
    "inventory.label.MRN": "MRN",
    "inventory.label.GRV": "GRV",
    "inventory.label.Submit": "Enviar",
  },

  zh_CN: {
    "inventory.label.EditGRV": "编辑 GRV",
    "inventory.label.Edit_MRN": "编辑 MRN",
    "inventory.label.CreateMRN": "创建 MRN",
    "inventory.label.DeleteItemDetail": "删除物品详情",
  "inventory.label.EditQuality": "编辑质量",
  "inventory.label.Quality": "质量",
  "inventory.label.ViewTraker": "查看跟踪器",
  "inventory.label.EntityName": "实体名称",
  "inventory.label.ItemDescription": "物品描述",
  "inventory.label.ItemCode": "物品代码",
  "inventory.label.AccountNumber": "账户号码",
  "inventory.label.ChipId": "芯片ID",
  "inventory.label.IsPairing": "是否配对",
  "inventory.label.PairedItemId": "配对物品ID",
  "inventory.label.PairedItem": "配对物品",
  "inventory.label.WarrantyDate": "保修日期",
  "inventory.label.ItemModel": "物品型号",
  "inventory.label.status": "状态",
  "inventory.label.EditItemDetail": "编辑物品详情",
  "inventory.label.CreateStockUpload": "创建库存上传",
  "inventory.label.SelectStatus": "选择状态",
  "inventory.label.SelectDescription": "选择描述",
  "inventory.label.SelectBusinessEntity": "选择业务实体",
  "inventory.label.Warranty": "保修",
  "inventory.label.SupplierCode": "供应商代码",
  "inventory.label.GrnId": "GRN编号",
  "inventory.label.SerialNo": "序列号",
  "inventory.label.ViewItemDetail": "查看物品详情",
  "inventory.label.Office": "办公室",
    "inventory.label.RefType": "参考类型",
  "inventory.label.TransactionDate": "交易日期",
  "inventory.label.Movement": "移动",
  "inventory.label.FromOffice": "来源办公室",
  "inventory.label.ToOffice": "目标办公室",
  "inventory.label.TrackHistory": "跟踪历史",
  "inventory.label.SerialNumber": "序列号",
  "inventory.label.ProvisionSerialNumber": "配置序列号",
  "inventory.label.EditItemDetail": "编辑物品详情",
    "inventory.label.Download_Uploaded_File": "下载已上传的文件",
    "inventory.label.Download_Log_File": "下载日志文件",
    "inventory.label.Description": "描述",
    "inventory.label.Browse_file_to_Upload": "浏览文件以上传",
    "inventory.label.Download_From_here": "从这里下载",
    "inventory.label.SelectItem": "选择项",
    "inventory.label.SelectModel": "选择模型",
    "inventory.label.Browse_file_to_Upload": "浏览文件以上传",
    "inventory.label.Download_From_here": "从这里下载",
    "inventory.label.MRN_Id": "MRN Id",
    "inventory.label.Type": "类型",
    "inventory.label.CartoonTransfer": "卡通传输",
    "inventory.label.Are_you_sure_?": "你确定吗？",
  "inventory.label.Done": "完成",
  "inventory.label.RefType": "参考类型",
  "inventory.label.Movement": "移动",
  "inventory.label.TransactionDate": "交易日期",
  "inventory.label.ToOffice": "至办公室",
  "inventory.label.FromOffice": "从办公室",
  "inventory.label.TrackHistory": "追踪记录",
  "inventory.label.SerialNumber": "序列号",
  "inventory.label.ProvisionSerialNumber": "预配序列号",
  "inventory.label.SelectItem": "选择项目",
  "inventory.label.Quality": "质量",
  "inventory.label.EditItemDetail": "编辑项目详情",
  "inventory.label.Assets": "资产",
  "inventory.label.NoGenerator": "无生成器",
  "inventory.label.Edit": "编辑",
  "inventory.label.CreateStockUpload": "创建库存上传",
  "inventory.label.Delete": "删除",
  "inventory.label.View": "查看",
  "inventory.label.SelectStatus": "选择状态",
  "inventory.label.SelectDescription": "选择描述",
  "inventory.label.SelectBusinessEntity": "选择业务实体",
    "inventory.label.EditItemSale": "编辑商品销售",
  "inventory.label.Item": "商品",
  "inventory.label.TotalItemPrice": "商品总价",
  "inventory.label.UnitPrice": "单价",
  "inventory.label.RequestedQuantity": "请求数量",
  "inventory.label.Charge": "费用",
  "inventory.label.To_ORG": "至组织",
  "inventory.label.ToOrganization": "至组织",
  "inventory.label.FromOrganization": "来自组织",
  "inventory.label.From_ORG": "来自组织",
  "inventory.label.Type": "类型",
  "inventory.label.Notes": "备注",
    "inventory.label.SelectSearch": "选择搜索",
  "inventory.label.CreateGRV": "创建 GRV",
  "inventory.label.Type": "类型",
  "inventory.label.Item": "物品",
  "inventory.label.Notes": "备注",
  "inventory.label.PurchasedFrom": "购买自",
  "inventory.label.PurchaseBy": "购买人",
  "inventory.label.Charge": "费用",
  "inventory.label.TotalItemPrice?": "商品总价？",
  "inventory.label.DiscountType": "折扣类型",
  "inventory.label.DiscountRate": "折扣率",
  "inventory.label.UnitPrice": "单价",
  "inventory.label.View_GRV": "查看 GRV",
  "inventory.label.Delete": "删除",
  "inventory.label.DeleteItemModel": "删除物品型号",
  "inventory.label.View_MRN": "查看 MRN",
  "inventory.label.View_ItemSales": "查看商品销售",
    "inventory.label.CreateNewContract": "创建新合同",
  "inventory.label.EditFeeMaster": "编辑费用主档",
  "inventory.label.GRVId": "GRV编号",
  "inventory.label.SerialNo": "序列号",
  "inventory.label.MRNId": "MRN编号",
  "inventory.label.SalesId": "销售编号",
  "inventory.label.Are_you_sure?": "你确定吗？",
  "inventory.label.DeleteItemSale": "删除商品销售",
  "inventory.label.delete": "删除",
  "inventory.label.MoveCarton": "移动纸箱",
  "inventory.label.MoveItems": "移动物品",
  "inventory.label.BulkStockTransfer": "批量库存转移",
  "inventory.label.Create_MRN/GRV": "创建MRN/GRV",
  "inventory.label.CreateItemSale": "创建商品销售",
    "entity.label.Edit": "编辑",
  "entity.label.Delete": "删除",
  "entity.label.DeleteItemModel": "删除项目模型",
  "entity.label.Item": "项目",
  "entity.label.DeleteItem": "删除项目",
    "inventory.label.DeleteItemDetails": "删除项目详情",
    "inventory.label.header": "货物收据",
    "inventory.label.id": "编号",
    "inventory.label.Purchase Date": "采购日期",
    "inventory.label.Supplier Code": "供应商代码",
    "inventory.label.Entity Name": "实体名称",
    "inventory.label.Save": "保存",
    "inventory.label.Cancel": "取消",
    "inventory.label.Edit": "编辑",
    "inventory.label.Ok": "确定",
    "inventory.label.Reset": "重置",
    "inventory.label.Update": "更新",
    "inventory.label.PinNo": "PIN 号码",
    "inventory.label.Delete": "删除",
    "inventory.label.Value": "值",
    "inventory.label.Confirm": "确认",
    "inventory.label.PinType": "PIN 类型",
    "inventory.label.CustomerId": "客户 ID",
    "inventory.label.SerialNo": "序列号",
    "inventory.label.OfficeId": "办公室 ID",
    "inventory.label.BatchName": "批次名称",
    "inventory.label.ManageVoucherPins": "管理凭证 PIN",
    "inventory.label.ContractType": "合同类型",
    "inventory.label.ContractUnit": "合同单位",
    "inventory.label.ViewGoodsReceipt": "查看货物收据",
    "inventory.label.ViewItemDetail": "查看商品详情",
    "inventory.label.ItemDescription": "商品描述",
    "inventory.label.OrderedQuantity": "订购数量",
    "inventory.label.ReceivedQuantity": "接收数量",
    "inventory.label.AvailableActions": "可用操作",
    "inventory.label.RequestedDate": "请求日期",
    "inventory.label.RequestedBy": "请求人",
    "inventory.label.RequestedFrom": "请求来源",
    "inventory.label.business_entity_name": "业务实体名称",
    "inventory.label.Item Description": "物品描述",
    "inventory.label.Ordered Quantity": "订购数量",
    "inventory.label.Received Quantity": "收到数量",
    "inventory.label.Balance Quantity": "余量数量",
    "inventory.label.status": "状态",
    "inventory.label.action": "操作",
    "inventory.label.Create Goods Receipt": "创建货物收据",
    "inventory.label.Purchase No": "购买编号",
    "inventory.label.Supplier": "供应商",
    "inventory.label.Office Id": "办公室ID",
    "inventory.label.Item Code": "商品代码",
    "inventory.label.Ordered Quantity": "订购数量",
    "inventory.label.Edit Goods Receipt": "编辑货物收据",
    "stockUpload.label.header": " 库存上传",
    "stockUpload.label.Entity Name": " 实体名称",
    "stockUpload.label.Item Description": "物品描述 ",
    "stockUpload.label.Item Code": " 物品代码",
    "stockUpload.label.AccountNumber": " 帐号",
    "stockUpload.label.Chip Id": " 芯片ID",
    "stockUpload.label.Is Pairing": " 是否配对",
    "stockUpload.label.Paired ItemId": "配对物品ID ",
    "stockUpload.label.Paired Item": " 配对物品",
    "stockUpload.label.Serial Number": " 序列号",
    "stockUpload.label.Warranty Date": "保修日期 ",
    "stockUpload.label.Item Model": " 物品型号",
    "stockTransfer.label.header": "库存转移",
    "stockTransfer.label.Id": "ID",
    "stockTransfer.label.Requested Date": "请求日期",
    "stockTransfer.label.Requested By": "请求者",
    "stockTransfer.label.Request From": "请求来源",
    "stockTransfer.label.Item Description": "物品描述",
    "stockTransfer.label.Ordered Quantity": "订购数量",
    "stockTransfer.label.Received Quantity": "收到数量",
    "stockTransfer.label.Create Item Sale": "创建物品销售",
    "stockTransfer.label.Create MRN": "创建MRN",
    "stockTransfer.label.Create GRV": "创建GRV",
    "stockTransfer.label.Delete Item Sale": "删除物品销售",
    "stockTransfer.label.Are you sure?": "您确定吗？",
    "stockTransfer.label.Cancel": "取消",
    "stockTransfer.label.Ok": "确定",
    "stockUpload.label.add.Add Stock Upload": "添加库存上传",
    "stockUpload.label.add.Individual Load": "单独加载",
    "stockUpload.label.add.Bulk Load": "批量加载",
    "stockUpload.label.add.GRN ID": "GRN 编号",
    "stockUpload.label.add.itemDescription": "商品描述",
    "stockUpload.label.add.Suplier Code": "供应商代码",
    "stockUpload.label.add.Received Quantity": "收到数量",
    "stockUpload.label.add.Entity Name": "实体名称",
    "stockUpload.label.add.Ordered Quantity": "订购数量",
    "stockUpload.label.add.Quality": "质量",
    "stockUpload.label.add.Item Model": "商品型号",
    "stockUpload.label.add.OEM Type": "OEM 类型",
    "stockUpload.label.add.LM Type": "LM 类型",
    "stockUpload.label.add.Serial No": "序列号",
    "stockUpload.label.add.Provision No": "预留号",
    "stockUpload.label.add.Paired Item": "配对商品",
    "stockUpload.label.add.Is Paired": "已配对",
    "stockUpload.label.add.Remarks": "备注",
    "stockUpload.label.add.Carton No": "箱号",
    "stockUpload.label.add.Select Name": "选择名称",
    "stockUpload.label.select_bulk_upload_type": "选择批量上传类型",
    "stockUpload.label.add.Description": "描述",
    "stockUpload.label.add.Reset": "重置",
    "stockUpload.label.add.Save": "保存",
    "stockUpload.label.add.Upload & Process": "上传并处理",
    "stockUpload.label.add.Upload Process": "上传处理",
    "stockUpload.label.add.Upload File Path": "上传文件路径",
    "stockUpload.label.add.Process Date": "处理日期",
    "stockUpload.label.add.Process/Total Records": "处理/总记录",
    "Create StockUpload": "创建库存上传",
    "Edit Item Detail": "编辑商品详细信息",
    "Provision Serial Number": "预留序列号",
    "Serial Number": "序列号",
    "Track History": "跟踪历史",
    "Ref Type": "参考类型",
    "Transaction Date": "交易日期",
    Movement: "移动",
    "From Office": "从办公室",
    "To Office": "到办公室",
    Done: "完成",
    Type: "类型",
    "Edit Item Sale": "编辑商品销售",
    Item: "商品",
    "From ORG": "来自组织",
    "To ORG": "到组织",
    Charge: "费用",
    "Requested Quantity": "请求数量",
    "Unit Price": "单价",
    "Total Item Price": "商品总价",
    "Create Item Sale": "创建商品销售",
    "Purchased From": "购买自",
    "Purchase By": "购买者",
    "Discount Type": "折扣类型",
    "Discount Rate": "折扣率",
    "Delete Item Model": "删除商品型号",
    "View ItemSales": "查看商品销售",
    "Create MRN": "创建MRN",
    "View MRN": "查看MRN",
    "Edit MRN": "编辑MRN",
    "Create GRV": "创建GRV",
    "View GRV": "查看GRV",
    "Edit GRV": "编辑GRV",
    Notes: "注释",
    "View Goods Receipt": "查看货物收据",
    "MRN Id": "MRN 编号",
    "Cartoon Transfer": "卡通转移",
    "inventory.label.GoodsReceipt": "貨物收據",
    "inventory.label.StockUpload": "库存上传",
    "inventory.label.StockTransfer": "库存调拨",
    "inventory.label.ItemSale": "商品销售",
    "inventory.label.MRN": "MRN",
    "inventory.label.GRV": "GRV",
    "inventory.label.Submit": "提交",
  },

  hi: {
    "inventory.label.EditGRV": "GRV संपादित करें",
    "inventory.label.Edit_MRN": "MRN संपादित करें",
    "inventory.label.CreateMRN": "MRN बनाएँ",
    "inventory.label.DeleteItemDetail": "आइटम विवरण हटाएं",
  "inventory.label.EditQuality": "गुणवत्ता संपादित करें",
  "inventory.label.Quality": "गुणवत्ता",
  "inventory.label.ViewTraker": "ट्रैकर देखें",
  "inventory.label.EntityName": "इकाई का नाम",
  "inventory.label.ItemDescription": "आइटम विवरण",
  "inventory.label.ItemCode": "आइटम कोड",
  "inventory.label.AccountNumber": "खाता संख्या",
  "inventory.label.ChipId": "चिप आईडी",
  "inventory.label.IsPairing": "क्या जोड़ा गया है",
  "inventory.label.PairedItemId": "जोड़ा गया आइटम आईडी",
  "inventory.label.PairedItem": "जोड़ा गया आइटम",
  "inventory.label.WarrantyDate": "वारंटी तिथि",
  "inventory.label.ItemModel": "आइटम मॉडल",
  "inventory.label.status": "स्थिति",
  "inventory.label.EditItemDetail": "आइटम विवरण संपादित करें",
  "inventory.label.CreateStockUpload": "स्टॉक अपलोड बनाएं",
  "inventory.label.SelectStatus": "स्थिति चुनें",
  "inventory.label.SelectDescription": "विवरण चुनें",
  "inventory.label.SelectBusinessEntity": "व्यवसाय इकाई चुनें",
  "inventory.label.Warranty": "वारंटी",
  "inventory.label.SupplierCode": "आपूर्तिकर्ता कोड",
  "inventory.label.GrnId": "GRN आईडी",
  "inventory.label.SerialNo": "सीरियल नंबर",
  "inventory.label.ViewItemDetail": "आइटम विवरण देखें",
  "inventory.label.Office": "कार्यालय",
    "inventory.label.RefType": "संदर्भ प्रकार",
  "inventory.label.TransactionDate": "लेन-देन की तारीख",
  "inventory.label.Movement": "गति",
  "inventory.label.FromOffice": "कार्यालय से",
  "inventory.label.ToOffice": "कार्यालय को",
  "inventory.label.TrackHistory": "ट्रैक इतिहास",
  "inventory.label.SerialNumber": "क्रमांक",
  "inventory.label.ProvisionSerialNumber": "प्रावधान क्रमांक",
  "inventory.label.EditItemDetail": "आइटम विवरण संपादित करें",
    "inventory.label.Download_Uploaded_File": "डाउनलोड अपलोड किया गया फ़ाइल",
    "inventory.label.Download_Log_File": "डाउनलोड लॉग फ़ाइल",
    "inventory.label.Description": "विवरण",
    "inventory.label.Browse_file_to_Upload": "अपलोड करने के लिए फ़ाइल ब्राउज़ करें",
    "inventory.label.Download_From_here": "यहां से डाउनलोड करें",
    "inventory.label.SelectItem": "आइटम चुनें",
    "inventory.label.SelectModel": "मॉडल चुनें",
    "inventory.label.Browse_file_to_Upload": "अपलोड करने के लिए फ़ाइल ब्राउज़ करें",
    "inventory.label.Download_From_here": "यहां से डाउनलोड करें",
    "inventory.label.MRN_Id": "MRN आईडी",
    "inventory.label.Type": "प्रकार",
    "inventory.label.CartoonTransfer": "कार्टून ट्रांसफर",
    "inventory.label.Are_you_sure_?": "क्या आप सुनिश्चित हैं?",
  "inventory.label.Done": "पूर्ण",
  "inventory.label.RefType": "संदर्भ प्रकार",
  "inventory.label.Movement": "गति",
  "inventory.label.TransactionDate": "लेन-देन की तारीख",
  "inventory.label.ToOffice": "कार्यालय को",
  "inventory.label.FromOffice": "कार्यालय से",
  "inventory.label.TrackHistory": "इतिहास ट्रैक करें",
  "inventory.label.SerialNumber": "क्रम संख्या",
  "inventory.label.ProvisionSerialNumber": "प्रावधान क्रम संख्या",
  "inventory.label.SelectItem": "आइटम चुनें",
  "inventory.label.Quality": "गुणवत्ता",
  "inventory.label.EditItemDetail": "आइटम विवरण संपादित करें",
  "inventory.label.Assets": "संपत्तियाँ",
  "inventory.label.NoGenerator": "कोई जनरेटर नहीं",
  "inventory.label.Edit": "संपादित करें",
  "inventory.label.CreateStockUpload": "स्टॉक अपलोड बनाएं",
  "inventory.label.Delete": "हटाएं",
  "inventory.label.View": "देखें",
  "inventory.label.SelectStatus": "स्थिति चुनें",
  "inventory.label.SelectDescription": "विवरण चुनें",
  "inventory.label.SelectBusinessEntity": "व्यवसाय इकाई चुनें",
    "inventory.label.EditItemSale": "आइटम बिक्री संपादित करें",
  "inventory.label.Item": "आइटम",
  "inventory.label.TotalItemPrice": "कुल आइटम मूल्य",
  "inventory.label.UnitPrice": "इकाई मूल्य",
  "inventory.label.RequestedQuantity": "अनुरोधित मात्रा",
  "inventory.label.Charge": "शुल्क",
  "inventory.label.To_ORG": "से संगठन",
  "inventory.label.ToOrganization": "से संगठन",
  "inventory.label.FromOrganization": "से संगठन",
  "inventory.label.From_ORG": "से संगठन",
  "inventory.label.Type": "प्रकार",
  "inventory.label.Notes": "टिप्पणियाँ",
    "inventory.label.SelectSearch": "खोज चुनें",
  "inventory.label.CreateGRV": "GRV बनाएँ",
  "inventory.label.Type": "प्रकार",
  "inventory.label.Item": "आइटम",
  "inventory.label.Notes": "टिप्पणियाँ",
  "inventory.label.PurchasedFrom": "से खरीदा गया",
  "inventory.label.PurchaseBy": "द्वारा खरीदा गया",
  "inventory.label.Charge": "शुल्क",
  "inventory.label.TotalItemPrice?": "कुल आइटम मूल्य?",
  "inventory.label.DiscountType": "छूट प्रकार",
  "inventory.label.DiscountRate": "छूट दर",
  "inventory.label.UnitPrice": "इकाई मूल्य",
  "inventory.label.View_GRV": "GRV देखें",
  "inventory.label.Delete": "हटाएं",
  "inventory.label.DeleteItemModel": "आइटम मॉडल हटाएं",
  "inventory.label.View_MRN": "MRN देखें",
  "inventory.label.View_ItemSales": "आइटम बिक्री देखें",
    "inventory.label.CreateNewContract": "नया अनुबंध बनाएं",
  "inventory.label.EditFeeMaster": "शुल्क मास्टर संपादित करें",
  "inventory.label.GRVId": "GRV आईडी",
  "inventory.label.SerialNo": "क्रम संख्या",
  "inventory.label.MRNId": "MRN आईडी",
  "inventory.label.SalesId": "बिक्री आईडी",
  "inventory.label.Are_you_sure?": "क्या आप निश्चित हैं?",
  "inventory.label.DeleteItemSale": "आइटम बिक्री हटाएं",
  "inventory.label.delete": "हटाएं",
  "inventory.label.MoveCarton": "कार्टन स्थानांतरित करें",
  "inventory.label.MoveItems": "आइटम स्थानांतरित करें",
  "inventory.label.BulkStockTransfer": "थोक स्टॉक ट्रांसफर",
  "inventory.label.Create_MRN/GRV": "MRN/GRV बनाएं",
  "inventory.label.CreateItemSale": "आइटम बिक्री बनाएं",
    "entity.label.Edit": "संपादित करें",
  "entity.label.Delete": "हटाएं",
  "entity.label.DeleteItemModel": "आइटम मॉडल हटाएं",
  "entity.label.Item": "आइटम",
  "entity.label.DeleteItem": "आइटम हटाएं",
    "inventory.label.DeleteItemDetails": "आइटम विवरण हटाएं",
    "inventory.label.header": "वस्तु स्वीकृति",
    "inventory.label.id": "आईडी",
    "inventory.label.Purchase Date": "क्रय तिथि",
    "inventory.label.Supplier Code": "प्रदायक कोड",
    "inventory.label.Entity Name": "एंटिटी का नाम",
    "inventory.label.Save": "सहेजें",
    "inventory.label.Cancel": "रद्द करें",
    "inventory.label.Edit": "संपादित करें",
    "inventory.label.Ok": "ठीक है",
    "inventory.label.Reset": "रीसेट करें",
    "inventory.label.Update": "अपडेट करें",
    "inventory.label.PinNo": "पिन नंबर",
    "inventory.label.Delete": "हटाएँ",
    "inventory.label.Value": "मूल्य",
    "inventory.label.Confirm": "पुष्टि करें",
    "inventory.label.PinType": "पिन प्रकार",
    "inventory.label.CustomerId": "ग्राहक आईडी",
    "inventory.label.SerialNo": "क्रमांक",
    "inventory.label.OfficeId": "कार्यालय आईडी",
    "inventory.label.BatchName": "बैच नाम",
    "inventory.label.ManageVoucherPins": "वाउचर पिन प्रबंधित करें",
    "inventory.label.ContractType": "अनुबंध प्रकार",
    "inventory.label.ContractUnit": "अनुबंध इकाई",
    "inventory.label.ViewGoodsReceipt": "माल की रसीद देखें",
    "inventory.label.ViewItemDetail": "आइटम विवरण देखें",
    "inventory.label.ItemDescription": "आइटम विवरण",
    "inventory.label.OrderedQuantity": "आदेशित मात्रा",
    "inventory.label.ReceivedQuantity": "प्राप्त मात्रा",
    "inventory.label.AvailableActions": "उपलब्ध क्रियाएँ",
    "inventory.label.RequestedDate": "अनुरोधित तिथि",
    "inventory.label.RequestedBy": "अनुरोधकर्ता",
    "inventory.label.RequestedFrom": "अनुरोध प्राप्त हुआ",
    "inventory.label.business_entity_name": "व्यापार इकाई का नाम",
    "inventory.label.Item Description": "आइटम विवरण",
    "inventory.label.Ordered Quantity": "आदेशित मात्रा",
    "inventory.label.Received Quantity": "प्राप्त मात्रा",
    "inventory.label.Balance Quantity": "शेष मात्रा",
    "inventory.label.status": "स्थिति",
    "inventory.label.action": "कार्रवाई",
    "inventory.label.Create Goods Receipt": "माल के रसीद बनाएं",
    "inventory.label.Purchase No": "क्रय संख्या",
    "inventory.label.Supplier": "आपूर्तिकर्ता",
    "inventory.label.Office Id": "कार्यालय आईडी",
    "inventory.label.Item Code": "आइटम कोड",
    "inventory.label.Ordered Quantity": "आदेशित मात्रा",
    "inventory.label.Edit Goods Receipt": "माल के रसीद को संपादित करें",
    "stockUpload.label.header": "  स्टॉक अपलोड",
    "stockUpload.label.Entity Name": " एंटिटी का नाम",
    "stockUpload.label.Item Description": " आइटम विवरण",
    "stockUpload.label.Item Code": " आइटम कोड",
    "stockUpload.label.AccountNumber": "खाता संख् ",
    "stockUpload.label.Chip Id": " चिप आईडी",
    "stockUpload.label.Is Pairing": " क्या पेयरिंग है",
    "stockUpload.label.Paired ItemId": " पेयर्ड आइटम आईडी",
    "stockUpload.label.Paired Item": "पेयर्ड आइटम ",
    "stockUpload.label.Serial Number": "सीरियल नंबर ",
    "stockUpload.label.Warranty Date": " वारंटी दिनांक",
    "stockUpload.label.Item Model": " आइटम मॉडल",
    "stockTransfer.label.header": "स्टॉक ट्रांसफर",
    "stockTransfer.label.Id": "आईडी",
    "stockTransfer.label.Requested Date": "अनुरोधित तिथि",
    "stockTransfer.label.Requested By": "अनुरोधक",
    "stockTransfer.label.Request From": "अनुरोध से",
    "stockTransfer.label.Item Description": "आइटम विवरण",
    "stockTransfer.label.Ordered Quantity": "आदेशित मात्रा",
    "stockTransfer.label.Received Quantity": "प्राप्त मात्रा",
    "stockTransfer.label.Create Item Sale": "आइटम बिक्री बनाएं",
    "stockTransfer.label.Create MRN": "MRN बनाएं",
    "stockTransfer.label.Create GRV": "GRV बनाएं",
    "stockTransfer.label.Delete Item Sale": "आइटम बिक्री हटाएं",
    "stockTransfer.label.Are you sure?": "क्या आप सुनिश्चित हैं?",
    "stockTransfer.label.Cancel": "रद्द करें",
    "stockTransfer.label.Ok": "ठीक है",
    "stockUpload.label.add.Add Stock Upload": "स्टॉक अपलोड जोड़ें",
    "stockUpload.label.add.Individual Load": "व्यक्तिगत लोड",
    "stockUpload.label.add.Bulk Load": "थोक लोड",
    "stockUpload.label.add.GRN ID": "जीआरएन आईडी",
    "stockUpload.label.add.itemDescription": "आइटम विवरण",
    "stockUpload.label.add.Suplier Code": "आपूर्तिकर्ता कोड",
    "stockUpload.label.add.Received Quantity": "प्राप्त मात्रा",
    "stockUpload.label.add.Entity Name": "संस्था का नाम",
    "stockUpload.label.add.Ordered Quantity": "आदेशित मात्रा",
    "stockUpload.label.add.Quality": "गुणवत्ता",
    "stockUpload.label.add.Item Model": "आइटम मॉडल",
    "stockUpload.label.add.OEM Type": "ओईएम प्रकार",
    "stockUpload.label.add.LM Type": "एलएम प्रकार",
    "stockUpload.label.add.Serial No": "क्रमांक",
    "stockUpload.label.add.Provision No": "प्रावधान संख्या",
    "stockUpload.label.add.Paired Item": "संयुक्त आइटम",
    "stockUpload.label.add.Is Paired": "संयुक्त है",
    "stockUpload.label.add.Remarks": "टिप्पणियाँ",
    "stockUpload.label.add.Carton No": "कार्टन नंबर",
    "stockUpload.label.add.Select Name": "नाम चुनें",
    "stockUpload.label.select_bulk_upload_type":
      "बड़े पैमाने पर अपलोड प्रकार चुनें",
    "stockUpload.label.add.Description": "विवरण",
    "stockUpload.label.add.Reset": "रीसेट",
    "stockUpload.label.add.Save": "सहेजें",
    "stockUpload.label.add.Upload & Process": "अपलोड और प्रोसेस",
    "stockUpload.label.add.Upload Process": "अपलोड प्रक्रिया",
    "stockUpload.label.add.Upload File Path": "फ़ाइल पथ अपलोड करें",
    "stockUpload.label.add.Process Date": "प्रक्रिया तिथि",
    "stockUpload.label.add.Process/Total Records": "प्रक्रिया/कुल रिकॉर्ड",
    "Create StockUpload": "स्टॉक अपलोड बनाएं",
    "Edit Item Detail": "आइटम विवरण संपादित करें",
    "Provision Serial Number": "प्रावधान सीरियल नंबर",
    "Serial Number": "सीरियल नंबर",
    "Track History": "ट्रैक इतिहास",
    "Ref Type": "संदर्भ प्रकार",
    "Transaction Date": "लेन-देन तिथि",
    Movement: "गति",
    "From Office": "कार्यालय से",
    "To Office": "कार्यालय तक",
    Done: "किया हुआ",
    Type: "प्रकार",
    "Edit Item Sale": "आइटम बिक्री संपादित करें",
    Item: "आइटम",
    "From ORG": "संगठन से",
    "To ORG": "संगठन को",
    Charge: "शुल्क",
    "Requested Quantity": "अनुरोधित मात्रा",
    "Unit Price": "यूनिट मूल्य",
    "Total Item Price": "कुल आइटम मूल्य",
    "Create Item Sale": "आइटम बिक्री बनाएं",
    "Purchased From": "से खरीदा गया",
    "Purchase By": "खरीदा",
    "Discount Type": "डिस्काउंट प्रकार",
    "Discount Rate": "डिस्काउंट दर",
    "Delete Item Model": "आइटम मॉडल हटाएं",
    "View ItemSales": "वस्तु बिक्री देखें",
    "Create MRN": "MRN बनाएँ",
    "View MRN": "MRN देखें",
    "Edit MRN": "MRN संपादित करें",
    "Create GRV": "GRV बनाएँ",
    "View GRV": "GRV देखें",
    "Edit GRV": "GRV संपादित करें",
    Notes: "टिप्पणियाँ",
    "View Goods Receipt": "माल प्राप्ति देखें",
    "MRN Id": "MRN आईडी",
    "Cartoon Transfer": "कार्टून ट्रांसफर",
    "inventory.label.GoodsReceipt": "सामग्री रसीद",
    "inventory.label.StockUpload": "स्टॉक अपलोड",
    "inventory.label.StockTransfer": "स्टॉक ट्रांसफर",
    "inventory.label.ItemSale": "आइटम बिक्री",
    "inventory.label.MRN": "MRN",
    "inventory.label.GRV": "GRV",
    "inventory.label.Submit": "प्रस्तुत करें",
  },

  ka: {
    "inventory.label.EditGRV": "GRV რედაქტირება",
    "inventory.label.Edit_MRN": "MRN რედაქტირება",
    "inventory.label.CreateMRN": "MRN შექმნა",
    "inventory.label.DeleteItemDetail": "ელემენტის დეტალის წაშლა",
  "inventory.label.EditQuality": "ხარისხის რედაქტირება",
  "inventory.label.Quality": "ხარისხი",
  "inventory.label.ViewTraker": "ტრეკერის ნახვა",
  "inventory.label.EntityName": "ორგანიზაციის სახელი",
  "inventory.label.ItemDescription": "ელემენტის აღწერა",
  "inventory.label.ItemCode": "ელემენტის კოდი",
  "inventory.label.AccountNumber": "ანგარიშის ნომერი",
  "inventory.label.ChipId": "ჩიპის ID",
  "inventory.label.IsPairing": "დაწყვილებულია",
  "inventory.label.PairedItemId": "დაწყვილებული ელემენტის ID",
  "inventory.label.PairedItem": "დაწყვილებული ელემენტი",
  "inventory.label.WarrantyDate": "გარანტიის თარიღი",
  "inventory.label.ItemModel": "ელემენტის მოდელი",
  "inventory.label.status": "სტატუსი",
  "inventory.label.EditItemDetail": "ელემენტის დეტალის რედაქტირება",
  "inventory.label.CreateStockUpload": "მარაგის ატვირთვის შექმნა",
  "inventory.label.SelectStatus": "სტატუსის არჩევა",
  "inventory.label.SelectDescription": "აღწერის არჩევა",
  "inventory.label.SelectBusinessEntity": "ბიზნეს ერთეულის არჩევა",
  "inventory.label.Warranty": "გარანტია",
  "inventory.label.SupplierCode": "მომწოდებლის კოდი",
  "inventory.label.GrnId": "GRN ID",
  "inventory.label.SerialNo": "სერიული ნომერი",
  "inventory.label.ViewItemDetail": "დეტალის ნახვა",
  "inventory.label.Office": "ოფისი",
    "inventory.label.RefType": "ცნობის ტიპი",
  "inventory.label.TransactionDate": "ტრანზაქციის თარიღი",
  "inventory.label.Movement": "მოძრაობა",
  "inventory.label.FromOffice": "ოფისიდან",
  "inventory.label.ToOffice": "ოფისში",
  "inventory.label.TrackHistory": "ისტორიის კვალდაკვალ",
  "inventory.label.SerialNumber": "სერიული ნომერი",
  "inventory.label.ProvisionSerialNumber": "სარეზერვო სერიული ნომერი",
  "inventory.label.EditItemDetail": "ნივთის დეტალის რედაქტირება",
    "inventory.label.Download_Uploaded_File": "ჩამოტვირთვა ატვირთული ფაილი",
    "inventory.label.Download_Log_File": "ჩამოტვირთვა ლოგი ფაილი",
    "inventory.label.Description": "აღწერა",
    "inventory.label.Browse_file_to_Upload": "ფაილის მოძებნა ატვირთვა",
    "inventory.label.Download_From_here": "ჩამოტვირთვა აქედან",
    "inventory.label.SelectItem": "აირჩიეთ ნივთი",
    "inventory.label.SelectModel": "აირჩიეთ მოდელი",
    "inventory.label.Browse_file_to_Upload": "ფაილის მოძებნა ატვირთვა",
    "inventory.label.Download_From_here": "ჩამოტვირთვა აქედან",
    "inventory.label.MRN_Id": "MRN ID",
    "inventory.label.Type": "ტიპი",
    "inventory.label.CartoonTransfer": "კარტონის გადაცემა",
    "inventory.label.Are_you_sure_?": "დარწმუნებული ხარ?",
  "inventory.label.Done": "დასრულდა",
  "inventory.label.RefType": "ცნობარის ტიპი",
  "inventory.label.Movement": "მოძრაობა",
  "inventory.label.TransactionDate": "ტრანზაქციის თარიღი",
  "inventory.label.ToOffice": "ოფისში გაგზავნა",
  "inventory.label.FromOffice": "ოფისიდან გაგზავნა",
  "inventory.label.TrackHistory": "ისტორიის მიყოლა",
  "inventory.label.SerialNumber": "სერიული ნომერი",
  "inventory.label.ProvisionSerialNumber": "პროვიზიის სერიული ნომერი",
  "inventory.label.SelectItem": "აირჩიეთ ნივთი",
  "inventory.label.Quality": "ხარისხი",
  "inventory.label.EditItemDetail": "ნივთის დეტალების რედაქტირება",
  "inventory.label.Assets": "აქტივები",
  "inventory.label.NoGenerator": "გენერატორი არ არის",
  "inventory.label.Edit": "რედაქტირება",
  "inventory.label.CreateStockUpload": "საწყობის ატვირთვის შექმნა",
  "inventory.label.Delete": "წაშლა",
  "inventory.label.View": "ნახვა",
  "inventory.label.SelectStatus": "აირჩიეთ სტატუსი",
  "inventory.label.SelectDescription": "აირჩიეთ აღწერა",
  "inventory.label.SelectBusinessEntity": "აირჩიეთ ბიზნეს სუბიექტი",
    "inventory.label.EditItemSale": "საქონლის გაყიდვის რედაქტირება",
  "inventory.label.Item": "ნივთი",
  "inventory.label.TotalItemPrice": "ნივთის სრული ფასი",
  "inventory.label.UnitPrice": "ერთეულის ფასი",
  "inventory.label.RequestedQuantity": "მოთხოვნილი რაოდენობა",
  "inventory.label.Charge": "გადასახადი",
  "inventory.label.To_ORG": "ორგ-სთვის",
  "inventory.label.ToOrganization": "ორგანიზაციისთვის",
  "inventory.label.FromOrganization": "ორგანიზაციიდან",
  "inventory.label.From_ORG": "ორგ-დან",
  "inventory.label.Type": "ტიპი",
  "inventory.label.Notes": "შენიშვნები",
    "inventory.label.SelectSearch": "ძებნის არჩევა",
  "inventory.label.CreateGRV": "შექმენი GRV",
  "inventory.label.Type": "ტიპი",
  "inventory.label.Item": "ელემენტი",
  "inventory.label.Notes": "შენიშვნები",
  "inventory.label.PurchasedFrom": "შეძენილი ვინგან",
  "inventory.label.PurchaseBy": "შეძენილი ვიზე მიერ",
  "inventory.label.Charge": "გადასახადი",
  "inventory.label.TotalItemPrice?": "საერთო ღირებულება?",
  "inventory.label.DiscountType": "ფასდაკლების ტიპი",
  "inventory.label.DiscountRate": "ფასდაკლების მაჩვენებელი",
  "inventory.label.UnitPrice": "ერთეულის ფასი",
  "inventory.label.View_GRV": "ნახვა GRV",
  "inventory.label.Delete": "წაშლა",
  "inventory.label.DeleteItemModel": "მონაცემის მოდელის წაშლა",
  "inventory.label.View_MRN": "MRN-ის ნახვა",
  "inventory.label.View_ItemSales": "საქონლის გაყიდვების ნახვა",
    "inventory.label.CreateNewContract": "ახალი ხელშეკრულების შექმნა",
  "inventory.label.EditFeeMaster": "გადასახადის მთავარი რედაქტირება",
  "inventory.label.GRVId": "GRV ID",
  "inventory.label.SerialNo": "სერიული ნომერი",
  "inventory.label.MRNId": "MRN ID",
  "inventory.label.SalesId": "გაყიდვების ID",
  "inventory.label.Are_you_sure?": "დარწმუნებული ხართ?",
  "inventory.label.DeleteItemSale": "ელემენტის გაყიდვის წაშლა",
  "inventory.label.delete": "წაშლა",
  "inventory.label.MoveCarton": "ყუთის გადატანა",
  "inventory.label.MoveItems": "ელემენტების გადატანა",
  "inventory.label.BulkStockTransfer": "საწყობის მასიური გადატანა",
  "inventory.label.Create_MRN/GRV": "შექმენით MRN/GRV",
  "inventory.label.CreateItemSale": "ელემენტის გაყიდვის შექმნა",
    "entity.label.Edit": "რედაქტირება",
  "entity.label.Delete": "წაშლა",
  "entity.label.DeleteItemModel": "ელემენტის მოდელის წაშლა",
  "entity.label.Item": "ელემენტი",
  "entity.label.DeleteItem": "ელემენტის წაშლა",
    "inventory.label.DeleteItemDetails": "ელემენტის დეტალების წაშლა",
    "inventory.label.header": "ნივთების მიღება",
    "inventory.label.id": "ID",
    "inventory.label.Purchase Date": "შესყიდვის თარიღი",
    "inventory.label.Supplier Code": "მომწოდებლის კოდი",
    "inventory.label.Entity Name": "ენთიტეტის სახელი",
    "inventory.label.Save": "შენახვა",
    "inventory.label.Cancel": "გაუქმება",
    "inventory.label.Edit": "რედაქტირება",
    "inventory.label.Ok": "გაგრძელება",
    "inventory.label.Reset": "გადადგა",
    "inventory.label.Update": "განახლება",
    "inventory.label.PinNo": "პინის ნომერი",
    "inventory.label.Delete": "წაშლა",
    "inventory.label.Value": "ღირებულება",
    "inventory.label.Confirm": "დადასტურება",
    "inventory.label.PinType": "პინის ტიპი",
    "inventory.label.CustomerId": "კლიენტის ID",
    "inventory.label.SerialNo": "სერიული ნომერი",
    "inventory.label.OfficeId": "ოფისის ID",
    "inventory.label.BatchName": "ლოტის სახელი",
    "inventory.label.ManageVoucherPins": "ვაუჩერების პინების მართვა",
    "inventory.label.ContractType": "კონტრაქტის ტიპი",
    "inventory.label.ContractUnit": "კონტრაქტის ერთეული",
    "inventory.label.ViewGoodsReceipt": "ყიდვების საბუთის ნახვა",
    "inventory.label.ViewItemDetail": "ფართო დეტალების ნახვა",
    "inventory.label.ItemDescription": "პროდუქტის აღწერა",
    "inventory.label.OrderedQuantity": "შეკვეთილი რაოდენობა",
    "inventory.label.ReceivedQuantity": "მიღებული რაოდენობა",
    "inventory.label.AvailableActions": "დამატებითი მოქმედებები",
    "inventory.label.RequestedDate": "მოთხოვნის თარიღი",
    "inventory.label.RequestedBy": "მოთხოვნის მიერ",
    "inventory.label.RequestedFrom": "მოთხოვნილია",
    "inventory.label.business_entity_name": "ბიზნეს სუბიექტის სახელი",
    "inventory.label.Item Description": "ნივთის აღწერა",
    "inventory.label.Ordered Quantity": "შეკვეთული რაოდენობა",
    "inventory.label.Received Quantity": "მიღებული რაოდენობა",
    "inventory.label.Balance Quantity": "ნაშთის რაოდენობა",
    "inventory.label.status": "სტატუსი",
    "inventory.label.action": "ქმედება",
    "inventory.label.Create Goods Receipt": "საქონლის მიღების შექმნა",
    "inventory.label.Purchase No": "შესყიდვის ნომერი",
    "inventory.label.Supplier": "მომწოდებელი",
    "inventory.label.Office Id": "ოფისის ID",
    "inventory.label.Item Code": "პროდუქტის კოდი",
    "inventory.label.Ordered Quantity": "შესყიდვის რაოდენობა",
    "inventory.label.Edit Goods Receipt": "საქონლის მიღების რედაქტირება",
    "stockUpload.label.header": "  საწყო ატვირთვა",
    "stockUpload.label.Entity Name": "ენთიტის სახელი ",
    "stockUpload.label.Item Description": " ნივთის აღწერა",
    "stockUpload.label.Item Code": " ნივთის კოდი",
    "stockUpload.label.AccountNumber": " ანგარიშის ნომერი",
    "stockUpload.label.Chip Id": "ჩიპის ID ",
    "stockUpload.label.Is Pairing": "თუ ერთმანეთს აქვს ",
    "stockUpload.label.Paired ItemId": " თანამყოფი ნივთის ID",
    "stockUpload.label.Paired Item": " თანამყოფი ნივთი",
    "stockUpload.label.Serial Number": " სერიული ნომერი",
    "stockUpload.label.Warranty Date": "გარანტიის თარიღი ",
    "stockUpload.label.Item Model": " ნივთის მოდელი",
    "stockTransfer.label.header": "საწყობის გადადება",
    "stockTransfer.label.Id": "ID",
    "stockTransfer.label.Requested Date": "მოთხოვნილი თარიღი",
    "stockTransfer.label.Requested By": "მოთხოვნილი",
    "stockTransfer.label.Request From": "მოთხოვა",
    "stockTransfer.label.Item Description": "ნივთის აღწერა",
    "stockTransfer.label.Ordered Quantity": "შესაკრები რაოდენობა",
    "stockTransfer.label.Received Quantity": "მიღებული რაოდენობა",
    "stockTransfer.label.Create Item Sale": "ნივთის გაყიდვის შექმნა",
    "stockTransfer.label.Create MRN": "MRN შექმნა",
    "stockTransfer.label.Create GRV": "GRV შექმნა",
    "stockTransfer.label.Delete Item Sale": "ნივთის გაყიდვის წაშლა",
    "stockTransfer.label.Are you sure?": "დარწმუნებული ხარ?",
    "stockTransfer.label.Cancel": "გაუქმება",
    "stockTransfer.label.Ok": "Დიახ",
    "stockUpload.label.add.Add Stock Upload": "საწყობის ატვირთვა",
    "stockUpload.label.add.Individual Load": "ინდივიდუალური ჩატვირთვა",
    "stockUpload.label.add.Bulk Load": "ქილოვანი ჩატვირთვა",
    "stockUpload.label.add.GRN ID": "GRN ID",
    "stockUpload.label.add.itemDescription": "ნივთის აღწერა",
    "stockUpload.label.add.Suplier Code": "მომწოდებელის კოდი",
    "stockUpload.label.add.Received Quantity": "მიღებული რაოდენობა",
    "stockUpload.label.add.Entity Name": "ორგანიზაციის სახელი",
    "stockUpload.label.add.Ordered Quantity": "შეკვეთული რაოდენობა",
    "stockUpload.label.add.Quality": "ხარისხი",
    "stockUpload.label.add.Item Model": "ნივთის მოდელი",
    "stockUpload.label.add.OEM Type": "OEM ტიპი",
    "stockUpload.label.add.LM Type": "LM ტიპი",
    "stockUpload.label.add.Serial No": "სერიული ნომერი",
    "stockUpload.label.add.Provision No": "პროვიზიის ნომერი",
    "stockUpload.label.add.Paired Item": "ერთიანი ნივთი",
    "stockUpload.label.add.Is Paired": "დარეკებულია",
    "stockUpload.label.add.Remarks": "შენიშვნები",
    "stockUpload.label.add.Carton No": "ყუთის ნომერი",
    "stockUpload.label.add.Select Name": "სახელის შერჩევა",
    "stockUpload.label.select_bulk_upload_type":
      "აირჩიეთ ჯგუფური ატვირთვის ტიპი",
    "stockUpload.label.add.Description": "აღწერა",
    "stockUpload.label.add.Reset": "განულება",
    "stockUpload.label.add.Save": "შენახვა",
    "stockUpload.label.add.Upload & Process": "ატვირთვა და დამუშავება",
    "stockUpload.label.add.Upload Process": "ატვირთვის პროცესი",
    "stockUpload.label.add.Upload File Path": "ფაილის ატვირთვის მისამართი",
    "stockUpload.label.add.Process Date": "პროცესის თარიღი",
    "stockUpload.label.add.Process/Total Records": "პროცესი/სულ ჩანაწერები",
    "Create StockUpload": "საწყობის ატვირთვის შექმნა",
    "Edit Item Detail": "ნივთის დეტალების რედაქტირება",
    "Provision Serial Number": "პროვიზიის სერიული ნომერი",
    "Serial Number": "სერიული ნომერი",
    "Track History": "ისტორიის თვალთვალი",
    "Ref Type": "მიმოხილვის ტიპი",
    "Transaction Date": "ტრანზაქციის თარიღი",
    Movement: "მოძრაობა",
    "From Office": "ოფისიდან",
    "To Office": "ოფისზე",
    Done: "შესრულებულია",
    Type: "ტიპი",
    "Edit Item Sale": "პროდუქტის გაყიდვის რედაქტირება",
    Item: "პროდუქტი",
    "From ORG": "ორგანიზაციადაც",
    "To ORG": "ორგანიზაციაში",
    Charge: "გადასახდელი",
    "Requested Quantity": "მოთხოვნილი რაოდენობა",
    "Unit Price": "ერთეულის ფასი",
    "Total Item Price": "პროდუქტის სრული ფასი",
    "Create Item Sale": "პროდუქტის გაყიდვა",
    "Purchased From": "შეიძენა",
    "Purchase By": "შეძენილი",
    "Discount Type": "ფასდაკლების ტიპი",
    "Discount Rate": "ფასდაკლების კურსი",
    "Delete Item Model": "პროდუქტის მოდელის წაშლა",
    "View ItemSales": "ნახე ნივთის გაყიდვა",
    "Create MRN": "MRN შექმნა",
    "View MRN": "MRN-ის ნახვა",
    "Edit MRN": "MRN-ის რედაქტირება",
    "Create GRV": "GRV-ის შექმნა",
    "View GRV": "GRV-ის ნახვა",
    "Edit GRV": "GRV-ის რედაქტირება",
    Notes: "შინაარსი",
    "View Goods Receipt": "საჩამოთა მიღებას ნახვა",
    "MRN Id": "MRN იდენტიფიკაცია",
    "Cartoon Transfer": "კარტუნის გადატანა",
    "inventory.label.GoodsReceipt": "საქონლის ქვითარი",
    "inventory.label.StockUpload": "საწყობის ატვირთვა",
    "inventory.label.StockTransfer": "საწყობის გადადება",
    "inventory.label.ItemSale": "ნივთის გაყიდვა",
    "inventory.label.MRN": "MRN",
    "inventory.label.GRV": "GRV",
    "inventory.label.Submit": "გაგზავნა",
  },

  lo: {
    "inventory.label.EditGRV": "ແກ້ໄຂ GRV",
    "inventory.label.Edit_MRN": "ແກ້ໄຂ MRN",
    "inventory.label.CreateMRN": "ສ້າງ MRN",
    "inventory.label.DeleteItemDetail": "ລຶບລາຍລະອຽດລາຍການ",
"inventory.label.EditQuality": "ແກ້ໄຂຄຸນນະພາບ",
"inventory.label.Quality": "ຄຸນນະພາບ",
"inventory.label.ViewTraker": "ເບິ່ງການຕິດຕາມ",
"inventory.label.EntityName": "ຊື່ນິຕິບຸກຄົນ",
"inventory.label.ItemDescription": "ລາຍລະອຽດລາຍການ",
"inventory.label.ItemCode": "ລະຫັດລາຍການ",
"inventory.label.AccountNumber": "ເລກບັນຊີ",
"inventory.label.ChipId": "ລະຫັດຊິບ",
"inventory.label.IsPairing": "ຈັບຄູ່ຫຼືບໍ່",
"inventory.label.PairedItemId": "ID ລາຍການທີ່ຈັບຄູ່",
"inventory.label.PairedItem": "ລາຍການທີ່ຈັບຄູ່",
"inventory.label.WarrantyDate": "ວັນທີຮັບປະກັນ",
"inventory.label.ItemModel": "ຮູບແບບລາຍການ",
"inventory.label.status": "ສະຖານະ",
"inventory.label.EditItemDetail": "ແກ້ໄຂລາຍລະອຽດ",
"inventory.label.CreateStockUpload": "ສ້າງການອັບໂຫຼດສະຕ໋ອກ",
"inventory.label.SelectStatus": "ເລືອກສະຖານະ",
"inventory.label.SelectDescription": "ເລືອກຄຳອະທິບາຍ",
"inventory.label.SelectBusinessEntity": "ເລືອກນິຕິບຸກຄົນ",
"inventory.label.Warranty": "ການຮັບປະກັນ",
"inventory.label.SupplierCode": "ລະຫັດຜູ້ສະໜອງ",
"inventory.label.GrnId": "GRN ID",
"inventory.label.SerialNo": "ເລກລຳດັບ",
"inventory.label.ViewItemDetail": "ເບິ່ງລາຍລະອຽດ",
"inventory.label.Office": "ສຳນັກງານ",
    "inventory.label.RefType": "ປະເພດການອ້າງອີງ",
  "inventory.label.TransactionDate": "ວັນທີທຳການ",
  "inventory.label.Movement": "ການເຄື່ອນໄຫວ",
  "inventory.label.FromOffice": "ຈາກສຳນັກງານ",
  "inventory.label.ToOffice": "ໄປຫາສຳນັກງານ",
  "inventory.label.TrackHistory": "ປະຫວັດການຕິດຕາມ",
  "inventory.label.SerialNumber": "ເລກລຳດັບ",
  "inventory.label.ProvisionSerialNumber": "ເລກລຳດັບການຈັດຫາ",
  "inventory.label.EditItemDetail": "ແກ້ໄຂລາຍລະອຽດລາຍການ",
    "inventory.label.Download_Uploaded_File": "ດາວໂຫຼດໄຟລທີ່ອັບລູດ",
    "inventory.label.Download_Log_File": "ດາວໂຫຼດໄຟລລອກ",
    "inventory.label.Description": "ຄຳອະທິບາຍ",
    "inventory.label.Browse_file_to_Upload": "ເລືອກໄຟລທີ່ຈະອັບລູດ",
    "inventory.label.Download_From_here": "ດາວໂຫຼດຈາກທີ່ນີ້",
    "inventory.label.SelectItem": "ເລືອກລາຍການ",
    "inventory.label.SelectModel": "ເລືອກແບບ",
    "inventory.label.Browse_file_to_Upload": "ເລືອກໄຟລທີ່ຈະອັບລູດ",
    "inventory.label.Download_From_here": "ດາວໂຫຼດຈາກທີ້ນີ້",
    "inventory.label.MRN_Id": "MRN ເລກປະຈຳຕົວ",
    "inventory.label.Type": "ປະກອບ",
    "inventory.label.CartoonTransfer": "ການຖອນການຖາມການ",
    "inventory.label.Are_you_sure_?": "ເຈົ້າແນ່ໃຈບໍ?",
  "inventory.label.Done": "ແລ້ວ",
  "inventory.label.RefType": "ປະເພດອ້າງອີງ",
  "inventory.label.Movement": "ການເຄື່ອນໄຫວ",
  "inventory.label.TransactionDate": "ວັນທີ່ເຮັດລາຍການ",
  "inventory.label.ToOffice": "ສົ່ງໄປທີ່ຫ້ອງການ",
  "inventory.label.FromOffice": "ຈາກຫ້ອງການ",
  "inventory.label.TrackHistory": "ຕິດຕາມປະຫວັດ",
  "inventory.label.SerialNumber": "ເລກລຳດັບ",
  "inventory.label.ProvisionSerialNumber": "ເລກລຳດັບການຈັດສົ່ງ",
  "inventory.label.SelectItem": "ເລືອກລາຍການ",
  "inventory.label.Quality": "ຄຸນນະພາບ",
  "inventory.label.EditItemDetail": "ແກ້ໄຂລາຍລະອຽດ",
  "inventory.label.Assets": "ຊັບສິນ",
  "inventory.label.NoGenerator": "ບໍ່ມີຕົ້ນກຳເນີດ",
  "inventory.label.Edit": "ແກ້ໄຂ",
  "inventory.label.CreateStockUpload": "ສ້າງການອັບໂຫຼດສິນຄ້າ",
  "inventory.label.Delete": "ລຶບ",
  "inventory.label.View": "ເບິ່ງ",
  "inventory.label.SelectStatus": "ເລືອກສະຖານະ",
  "inventory.label.SelectDescription": "ເລືອກຄຳອະທິບາຍ",
  "inventory.label.SelectBusinessEntity": "ເລືອກນິຕິບຸກຄົນ",
    "inventory.label.EditItemSale": "ແກ້ໄຂການຂາຍສິນຄ້າ",
  "inventory.label.Item": "ລາຍການ",
  "inventory.label.TotalItemPrice": "ລາຄາລວມຂອງລາຍການ",
  "inventory.label.UnitPrice": "ລາຄາຕໍ່ຫນ່ວຍ",
  "inventory.label.RequestedQuantity": "ຈຳນວນທີ່ຮ້ອງຂໍ",
  "inventory.label.Charge": "ຄ່າບໍລິການ",
  "inventory.label.To_ORG": "ໄປ ORG",
  "inventory.label.ToOrganization": "ໄປອົງການ",
  "inventory.label.FromOrganization": "ຈາກອົງການ",
  "inventory.label.From_ORG": "ຈາກ ORG",
  "inventory.label.Type": "ປະເພດ",
  "inventory.label.Notes": "ໝາຍເຫດ",
    "inventory.label.SelectSearch": "ເລືອກການຊອກຫາ",
  "inventory.label.CreateGRV": "ສ້າງ GRV",
  "inventory.label.Type": "ປະເພດ",
  "inventory.label.Item": "ລາຍການ",
  "inventory.label.Notes": "ໝາຍເຫດ",
  "inventory.label.PurchasedFrom": "ຊື້ຈາກ",
  "inventory.label.PurchaseBy": "ຊື້ໂດຍ",
  "inventory.label.Charge": "ຄ່າໃຊ້ຈ່າຍ",
  "inventory.label.TotalItemPrice?": "ລາຄາລວມຂອງລາຍການ?",
  "inventory.label.DiscountType": "ປະເພດສ່ວນຫຼຸດ",
  "inventory.label.DiscountRate": "ອັດຕາສ່ວນຫຼຸດ",
  "inventory.label.UnitPrice": "ລາຄາຕໍ່ຫນ່ວຍ",
   "inventory.label.View_GRV": "ເບິ່ງ GRV",
  "inventory.label.Delete": "ລຶບ",
  "inventory.label.DeleteItemModel": "ລຶບແບບສິນຄ້າ",
  "inventory.label.View_MRN": "ເບິ່ງ MRN",
  "inventory.label.View_ItemSales": "ເບິ່ງການຂາຍສິນຄ້າ",
    "inventory.label.CreateNewContract": "ສ້າງສັນຍາໃໝ່",
  "inventory.label.EditFeeMaster": "ແກ້ໄຂຄ່າທີ່ຈ່າຍ",
  "inventory.label.GRVId": "GRV ID",
  "inventory.label.SerialNo": "ເລກຊຸດ",
  "inventory.label.MRNId": "MRN ID",
  "inventory.label.SalesId": "ເລກການຂາຍ",
  "inventory.label.Are_you_sure?": "ເຈົ້າແນ່ໃຈບໍ?",
  "inventory.label.DeleteItemSale": "ລຶບການຂາຍລາຍການ",
  "inventory.label.delete": "ລຶບ",
  "inventory.label.MoveCarton": "ຍ້າຍກ່ອງ",
  "inventory.label.MoveItems": "ຍ້າຍລາຍການ",
  "inventory.label.BulkStockTransfer": "ຍ້າຍສິນຄ້າຈຳນວນຫຼາຍ",
  "inventory.label.Create_MRN/GRV": "ສ້າງ MRN/GRV",
  "inventory.label.CreateItemSale": "ສ້າງການຂາຍລາຍການ",
    "entity.label.Edit": "ແກ້ໄຂ",
  "entity.label.Delete": "ລຶບ",
  "entity.label.DeleteItemModel": "ລຶບແບບຮູບລາຍການ",
  "entity.label.Item": "ລາຍການ",
  "entity.label.DeleteItem": "ລຶບລາຍການ",
    "inventory.label.DeleteItemDetails": "ລຶບລາຍລະອຽດລາຍການ",
    "inventory.label.header": "ຮັບສິນຄ້າ",
    "inventory.label.id": "ID",
    "inventory.label.Purchase Date": "ວັນຊື້",
    "inventory.label.Supplier Code": "ລະຫັດຜູ້ສະໜອງ",
    "inventory.label.Entity Name": "ຊື່ຜູ້ສະໜອງ",
    "inventory.label.Save": "ບັນທຶກ",
    "inventory.label.Cancel": "ຍົກເລີກ",
    "inventory.label.Edit": "ແກໄຂ",
    "inventory.label.Ok": "ແຈ້ງ",
    "inventory.label.Reset": "ຕັ້ງຄ່າໃໝ່",
    "inventory.label.Update": "ປ່ອນຂໍ້ມູນໃໝ່",
    "inventory.label.PinNo": "ເລກ PIN",
    "inventory.label.Delete": "ລຶບ",
    "inventory.label.Value": "ຄ່າ",
    "inventory.label.Confirm": "ຢືນຢັນ",
    "inventory.label.PinType": "ເພດ PIN",
    "inventory.label.CustomerId": "ID ລູກຄ້າ",
    "inventory.label.SerialNo": "ເລກປະະເພດ",
    "inventory.label.OfficeId": "ID ສະຖານທີ່ບໍລິສັດ",
    "inventory.label.BatchName": "ຊື່ບັດ",
    "inventory.label.ManageVoucherPins": "ຈັດການ PIN ບອນ",
    "inventory.label.ContractType": "ເປຍບັດປະເພດ",
    "inventory.label.ContractUnit": "ໜ່ວຍສັນຍາ",
    "inventory.label.ViewGoodsReceipt": "ເບິ່ງໃບບັນທຶກສິນຄ້າ",
    "inventory.label.ViewItemDetail": "ເບິ່ງລາຍລະອຽດສິນຄ້າ",
    "inventory.label.ItemDescription": "ລາຍລະອຽດສິນຄ້າ",
    "inventory.label.OrderedQuantity": "ຈຳນວນທີ່ສັ່ງ",
    "inventory.label.ReceivedQuantity": "ຈຳນວນທີ່ໄດ້ຮັບ",
    "inventory.label.AvailableActions": "ການຄະແນນທີ່ມີຢູ່",
    "inventory.label.RequestedDate": "ວັນທີ່ສະໝັດ",
    "inventory.label.RequestedBy": "ສໍາເລັດໂດຍ",
    "inventory.label.RequestedFrom": "ສໍາເລັດຈາກ",
    "inventory.label.business_entity_name": "ຊື່ບໍລິສັດທຸລະກິດ",
    "inventory.label.Item Description": "ລາຍລະອຽດສິນຄ້າ",
    "inventory.label.Ordered Quantity": "ຈຳນວນສັ່ງຊື້",
    "inventory.label.Received Quantity": "ຈຳນວນຮັບ",
    "inventory.label.Balance Quantity": "ຈຳນວນຍ່ອຍ",
    "inventory.label.status": "ສະຖານະ",
    "inventory.label.action": "ການປະມວນ",
    "inventory.label.Create Goods Receipt": "ສ້າງຮັບສີນຄ້າ",
    "inventory.label.Purchase No": "ເລກຊື້",
    "inventory.label.Supplier": "ຜູ້ສະໜອງ",
    "inventory.label.Office Id": "ລະຫັດອາກອນ",
    "inventory.label.Item Code": "ລະຫັດສິນຄ້າ",
    "inventory.label.Ordered Quantity": "ຈຳນວນສັ່ງຊື້",
    "inventory.label.Edit Goods Receipt": "ແກ້ໄຂຮັບສີນຄ້າ",
    "stockUpload.label.header": " ໂຫລດຂໍ້ມູນສາງ",
    "stockUpload.label.Entity Name": "ຊື່ແຫຼະ ",
    "stockUpload.label.Item Description": " ລາຍລະອຽດສິນຄ້າ",
    "stockUpload.label.Item Code": " ລະຫັດສິນຄ້າ",
    "stockUpload.label.AccountNumber": " ລະຫັດບັນຊີ",
    "stockUpload.label.Chip Id": " ລະຫັດຊິບ",
    "stockUpload.label.Is Pairing": "ມີຄໍລໍາດ້ວຍ ",
    "stockUpload.label.Paired ItemId": "ລະຫັດຂອງສິນຄ້າທີ່ມີຄໍລໍາ ",
    "stockUpload.label.Paired Item": " ສິນຄ້າທີ່ມີຄໍລໍາ",
    "stockUpload.label.Serial Number": "ຈໍານວນເລກໂລກ ",
    "stockUpload.label.Warranty Date": " ວັນທີລົງທຶນ",
    "stockUpload.label.Item Model": " ຕິດຕໍ່ສິນຄ້າ",
    "stockTransfer.label.header": "ການແຈ້ງການເຄື່ອງມື",
    "stockTransfer.label.Id": "ID",
    "stockTransfer.label.Requested Date": "ວັນທີ່ຮ້ອງຂໍ",
    "stockTransfer.label.Requested By": "ຮ້ອງຂໍຜ່ານ",
    "stockTransfer.label.Request From": "ຄວາມປອດດ້ວຍ",
    "stockTransfer.label.Item Description": "ລາຍລະອຽດສິນຄ້າ",
    "stockTransfer.label.Ordered Quantity": "ຈຳນວນສັ່ງຊື້",
    "stockTransfer.label.Received Quantity": "ຈຳນວນຮັບ",
    "stockTransfer.label.Create Item Sale": "ສ້າງການຂາຍສິນຄ້າ",
    "stockTransfer.label.Create MRN": "ສ້າງ MRN",
    "stockTransfer.label.Create GRV": "ສ້າງ GRV",
    "stockTransfer.label.Delete Item Sale": "ລຶບການຂາຍສິນຄ້າ",
    "stockTransfer.label.Are you sure?": "ທ່ານຕ້ອງການເຫຼົ່ານັບຕໍ່ລູກຄ້າແທ້ບໍ່?",
    "stockTransfer.label.Cancel": "ຍົກເລີກ",
    "stockTransfer.label.Ok": "ຕົກ​ລົງ",
    "stockUpload.label.add.Add Stock Upload": "ເພີ່ມອັດຕາມຊັບສິນຄ້າ",
    "stockUpload.label.add.Individual Load": "ການໂຫຼດຕົ້ນຄ້າພະເຈົ້າ",
    "stockUpload.label.add.Bulk Load": "ການໂຫຼດສົ່ງມື້",
    "stockUpload.label.add.GRN ID": "ລະຫັດ GRN",
    "stockUpload.label.add.itemDescription": "ລາຍລະອຽດສິນຄ້າ",
    "stockUpload.label.add.Suplier Code": "ລະຫັດຜູ້ສະໜອງ",
    "stockUpload.label.add.Received Quantity": "ຈໍານວນທີ່ໄດ້ຮັບ",
    "stockUpload.label.add.Entity Name": "ຊື່ສິນຄ້າ",
    "stockUpload.label.add.Ordered Quantity": "ຈໍານວນທີ່ສັ່ງຊື້",
    "stockUpload.label.add.Quality": "ຄວາມສາມາດ",
    "stockUpload.label.add.Item Model": "ຮູບແບບສິນຄ້າ",
    "stockUpload.label.add.OEM Type": "ປະເພດ OEM",
    "stockUpload.label.add.LM Type": "ປະເພດ LM",
    "stockUpload.label.add.Serial No": "ຫມາຍເລກຫມາຍ",
    "stockUpload.label.add.Provision No": "ເລກທີ່ໃຊ້ງານ",
    "stockUpload.label.add.Paired Item": "ສິນຄ້າຂອງການຄອບຄົວ",
    "stockUpload.label.add.Is Paired": "ແມ່ນຄອບຄົວ",
    "stockUpload.label.add.Remarks": "ໝາຍເຫດ",
    "stockUpload.label.add.Carton No": "ເລກມາດຕາສິນຄ້າ",
    "stockUpload.label.add.Select Name": "ເລືອກຊື່",
    "stockUpload.label.select_bulk_upload_type": "ເລືອກປະເພດການອັບໂຫລດປະຫວານ",
    "stockUpload.label.add.Description": "ລາຍລະອຽດ",
    "stockUpload.label.add.Reset": "ລ້າງຄ່າໃໝ່",
    "stockUpload.label.add.Save": "ບັນທຶກ",
    "stockUpload.label.add.Upload & Process": "ອັບໂຫຼດແລະປະຕິເສດ",
    "stockUpload.label.add.Upload Process": "ຂະບວນອັບໂຫຼດ",
    "stockUpload.label.add.Upload File Path": "ເສັ້ນທາງເຄື່ອງມືການອັບໂຫຼດ",
    "stockUpload.label.add.Process Date": "ວັນທີຂະບວນ",
    "stockUpload.label.add.Process/Total Records": "ການຂະບວນ/ສະຖານະທັງຫມົດ",
    "Create StockUpload": "ສ້າງການອັບເດດຊັບສິນຄ້າ",
    "Edit Item Detail": "ແກ້ໄຂລາຍລະອຽດສິນຄ້າ",
    "Provision Serial Number": "ເລກລຳດັບຕິດຕໍ່ການ",
    "Serial Number": "ເລກລຳດັບ",
    "Track History": "ຕິດຕໍ່ການປະຫວັດການ",
    "Ref Type": "ປະເພດອ້າງອີງ",
    "Transaction Date": "ວັນທີ່ເຮັດການ",
    Movement: "ການຍ້າຍກັນ",
    "From Office": "ຈາກຫ້ອງການ",
    "To Office": "ເຖິງຫ້ອງການ",
    Done: "ເຮັດແລ້ວ",
    Type: "ປະເພດ",
    "Edit Item Sale": "ແກ້ໄຂການຂາຍສິນຄ້າ",
    Item: "ສິນຄ້າ",
    "From ORG": "ຈາກອິນຕະເລການ",
    "To ORG": "ເຖິງອິນຕະເລການ",
    Charge: "ຄ່າບໍລິການ",
    "Requested Quantity": "ຈໍານວນທີ່ຕ້ອງການ",
    "Unit Price": "ລາຄາບາງສິ່ງ",
    "Total Item Price": "ລາຄາສິ່ງທັງໝົດ",
    "Create Item Sale": "ສ້າງການຂາຍສິນຄ້າ",
    "Purchased From": "ຈາກ",
    "Purchase By": "ຊື້ໂດຍ",
    "Discount Type": "ປະເພດສ່ວນລຸດ",
    "Discount Rate": "ອັດຕາຮ່ວມສ່ວນລຸດ",
    "Delete Item Model": "ລຶບຮູບແບບສິນຄ້າ",
    "View ItemSales": "ຊົມການຂາຍສິນຄ້າ",
    "Create MRN": "ສ້າງ MRN",
    "View MRN": "ເບິ່ງ MRN",
    "Edit MRN": "ແກ້ໄຂ MRN",
    "Create GRV": "ສ້າງ GRV",
    "View GRV": "ເບິ່ງ GRV",
    "Edit GRV": "ແກ້ໄຂ GRV",
    Notes: "ຫມາຍເຫດ",
    "View Goods Receipt": "ເບິ່ງຮັບສິນຄ້າ",
    "MRN Id": "ລະຫັດ MRN",
    "Cartoon Transfer": "ການໂຫມດປະສົມ",
    "inventory.label.GoodsReceipt": "ໃບຮັບເງິນ",
    "inventory.label.StockUpload": "ອັບເດດສະຕ໋ອກ",
    "inventory.label.StockTransfer": "ການໂອນສິນຄ້າ",
    "inventory.label.ItemSale": "ການຂາຍຜະລິດ",
    "inventory.label.MRN": "MRN",
    "inventory.label.GRV": "GRV",
    "inventory.label.Submit": "ສົ່ງ",
  },

  my_MM: {
    "inventory.label.EditGRV": "GRV ကိုတည်းဖြတ်ပါ",
    "inventory.label.Edit_MRN": "MRN ကိုတည်းဖြတ်ပါ",
"inventory.label.GoodsReceipt": "ကုန်ပစ္စည်းလက်ခံရရှိမှု",
    "inventory.label.DeleteItemDetail": "ပစ္စည်းအသေးစိတ် ဖျက်ရန်",
"inventory.label.EditQuality": "အရည်အသွေး တည်းဖြတ်ရန်",
"inventory.label.Quality": "အရည်အသွေး",
"inventory.label.ViewTraker": "ထောက်လှမ်းမှု ကြည့်ရန်",
"inventory.label.EntityName": "လုပ်ငန်းအမည်",
"inventory.label.ItemDescription": "ပစ္စည်းဖော်ပြချက်",
"inventory.label.ItemCode": "ပစ္စည်းကုဒ်",
"inventory.label.AccountNumber": "အကောင့်နံပါတ်",
"inventory.label.ChipId": "ချစ်ပ် ID",
"inventory.label.IsPairing": "တွဲဖက်ထားသည်",
"inventory.label.PairedItemId": "တွဲဖက် ID",
"inventory.label.PairedItem": "တွဲဖက်ထားသော ပစ္စည်း",
"inventory.label.WarrantyDate": "အာမခံသက်တမ်း",
"inventory.label.ItemModel": "ပစ္စည်းမော်ဒယ်",
"inventory.label.status": "အခြေအနေ",
"inventory.label.EditItemDetail": "အသေးစိတ် တည်းဖြတ်ရန်",
"inventory.label.CreateStockUpload": "စတော့အပ်လုဒ်ဖန်တီးရန်",
"inventory.label.SelectStatus": "အခြေအနေ ရွေးပါ",
"inventory.label.SelectDescription": "ဖော်ပြချက် ရွေးပါ",
"inventory.label.SelectBusinessEntity": "လုပ်ငန်း ရွေးပါ",
"inventory.label.Warranty": "အာမခံ",
"inventory.label.SupplierCode": "ပေးသွင်းသူ ကုဒ်",
"inventory.label.GrnId": "GRN ID",
"inventory.label.SerialNo": "စီးရီးနံပါတ်",
"inventory.label.ViewItemDetail": "အသေးစိတ်ကြည့်ရန်",
"inventory.label.Office": "ရုံး",
    "inventory.label.RefType": "ရည်ညွှန်းအမျိုးအစား",
  "inventory.label.TransactionDate": "ငွေလွှဲနေ့စွဲ",
  "inventory.label.Movement": "ရွှေ့ပြောင်းမှု",
  "inventory.label.FromOffice": "ရုံးမှ",
  "inventory.label.ToOffice": "ရုံးသို့",
  "inventory.label.TrackHistory": "မှတ်တမ်းလိုက်ခြင်း",
  "inventory.label.SerialNumber": "စီးရီးနံပါတ်",
  "inventory.label.ProvisionSerialNumber": "Provision စီးရီးနံပါတ်",
  "inventory.label.EditItemDetail": "ပစ္စည်းအသေးစိတ်ကို ပြင်ဆင်ပါ",
    "inventory.label.Download_Uploaded_File": "ဒေါင်းလုဒ်ပြီးသော ဖိုင်",
    "inventory.label.Download_Log_File": "ဒေါင်းလုဒ်လုပ်ထားသော ဖိုင်",
    "inventory.label.Description": "ဖေါ်ပြချက်",
    "inventory.label.Browse_file_to_Upload": "တင်ရန်ဖိုင်ကိုရွေးပါ",
    "inventory.label.Download_From_here": "ဒီနေရာကနေဒေါင်းလုဒ်လုပ်ပါ",
    "inventory.label.SelectItem": "ပစ္စည်းကိုရွေးပါ",
    "inventory.label.SelectModel": "မော်ဒယ်ကိုရွေးပါ",
    "inventory.label.Browse_file_to_Upload": "တင်ရန်ဖိုင်ကိုရွေးပါ",
    "inventory.label.Download_From_here": "ဒီနေရာကနေဒေါင်းလုဒ်လုပ်ပါ",
    "inventory.label.MRN_Id": "MRN အိုင်ဒီ",
    "inventory.label.Type": "အမျိုးအစား",
    "inventory.label.CartoonTransfer": "ကတ်တုန်းလွှဲပြောင်းမှု",
    "inventory.label.Are_you_sure_?": "သေချာပြီလား?",
  "inventory.label.Done": "ပြီးပြီ",
  "inventory.label.RefType": "အညွှန်းအမျိုးအစား",
  "inventory.label.Movement": "ရွှေ့ပြောင်းမှု",
  "inventory.label.TransactionDate": "ငွေလွှဲသည့်နေ့စွဲ",
  "inventory.label.ToOffice": "ရုံးသို့",
  "inventory.label.FromOffice": "ရုံးမှ",
  "inventory.label.TrackHistory": "မှတ်တမ်းလိုက်နာမှု",
  "inventory.label.SerialNumber": "စီးရီးနံပါတ်",
  "inventory.label.ProvisionSerialNumber": "Provision စီးရီးနံပါတ်",
  "inventory.label.SelectItem": "အမျိုးအစားရွေးချယ်ပါ",
  "inventory.label.Quality": "အရည်အသွေး",
  "inventory.label.EditItemDetail": "အကြောင်းအရာများကို တည်းဖြတ်ပါ",
  "inventory.label.Assets": "ပိုင်ဆိုင်မှုများ",
  "inventory.label.NoGenerator": "မရှိပါ",
  "inventory.label.Edit": "တည်းဖြတ်ရန်",
  "inventory.label.CreateStockUpload": "Stock Upload ဖန်တီးရန်",
  "inventory.label.Delete": "ဖျက်ရန်",
  "inventory.label.View": "ကြည့်ရန်",
  "inventory.label.SelectStatus": "အခြေအနေ ရွေးချယ်ပါ",
  "inventory.label.SelectDescription": "ဖော်ပြချက် ရွေးချယ်ပါ",
  "inventory.label.SelectBusinessEntity": "လုပ်ငန်းအဖွဲ့အစည်း ရွေးချယ်ပါ",
    "inventory.label.EditItemSale": "ပစ္စည်းရောင်းခြင်းကိုတည်းဖြတ်ပါ",
  "inventory.label.Item": "ပစ္စည်း",
  "inventory.label.TotalItemPrice": "ပစ္စည်းစုစုပေါင်းစျေးနှုန်း",
  "inventory.label.UnitPrice": "ယူနစ်စျေးနှုန်း",
  "inventory.label.RequestedQuantity": "တောင်းဆိုသောအရေအတွက်",
  "inventory.label.Charge": "ကောက်ခံငွေ",
  "inventory.label.To_ORG": "သို့ ORG",
  "inventory.label.ToOrganization": "အဖွဲ့အစည်းသို့",
  "inventory.label.FromOrganization": "အဖွဲ့အစည်းမှ",
  "inventory.label.From_ORG": "ORG မှ",
  "inventory.label.Type": "အမျိုးအစား",
  "inventory.label.Notes": "မှတ်ချက်များ",
    "inventory.label.SelectSearch": "ရှာဖွေမှုကို ရွေးပါ",
  "inventory.label.CreateGRV": "GRV ဖန်တီးရန်",
  "inventory.label.Type": "အမျိုးအစား",
  "inventory.label.Item": "အမျိုးအစား",
  "inventory.label.Notes": "မှတ်စုများ",
  "inventory.label.PurchasedFrom": "ဝယ်ယူခဲ့သောနေရာ",
  "inventory.label.PurchaseBy": "ဝယ်သူ",
  "inventory.label.Charge": "အခကြေးငွေ",
  "inventory.label.TotalItemPrice?": "စုစုပေါင်းကုန်ပစ္စည်းဈေးနှုန်း?",
  "inventory.label.DiscountType": "လျှော့စျေးအမျိုးအစား",
  "inventory.label.DiscountRate": "လျှော့စျေးနှုန်း",
  "inventory.label.UnitPrice": "ယူနစ်စျေးနှုန်း",
  "inventory.label.View_GRV": "GRV ကြည့်ရန်",
  "inventory.label.Delete": "ဖျက်ရန်",
  "inventory.label.DeleteItemModel": "ပစ္စည်းမော်ဒယ် ဖျက်ရန်",
  "inventory.label.View_MRN": "MRN ကြည့်ရန်",
  "inventory.label.View_ItemSales": "ပစ္စည်းရောင်းအား ကြည့်ရန်",
    "inventory.label.CreateNewContract": "စာချုပ်အသစ်ဖန်တီးပါ",
  "inventory.label.EditFeeMaster": "ကြေးအုပ်ချုပ်သူကိုတည်းဖြတ်ပါ",
  "inventory.label.GRVId": "GRV ID",
  "inventory.label.SerialNo": "အမှတ်စဥ်",
  "inventory.label.MRNId": "MRN ID",
  "inventory.label.SalesId": "အရောင်း ID",
  "inventory.label.Are_you_sure?": "သေချာပါသလား?",
  "inventory.label.DeleteItemSale": "ပစ္စည်းရောင်းအားဖျက်ရန်",
  "inventory.label.delete": "ဖျက်ရန်",
  "inventory.label.MoveCarton": "ကာတွန်ရွှေ့ပါ",
  "inventory.label.MoveItems": "ပစ္စည်းရွှေ့ပါ",
  "inventory.label.BulkStockTransfer": "စတော့အိတ်စုရွှေ့ခြင်း",
  "inventory.label.Create_MRN/GRV": "MRN/GRV ဖန်တီးရန်",
  "inventory.label.CreateItemSale": "ပစ္စည်းရောင်းရန်ဖန်တီးပါ",
    "entity.label.Edit": "တည်းဖြတ်ရန်",
  "entity.label.Delete": "ဖျက်ရန်",
  "entity.label.DeleteItemModel": "အိုင်တမ်မော်ဒယ်ဖျက်ရန်",
  "entity.label.Item": "အိုင်တမ်",
  "entity.label.DeleteItem": "အိုင်တမ်ဖျက်ရန်",
    "inventory.label.DeleteItemDetails": "အမျိုးအစားအသေးစိတ်ကို ဖျက်ပါ",
    "inventory.label.header": "ကုန်ပစ်သွင်း",
    "inventory.label.id": "အဆင့်",
    "inventory.label.Purchase Date": "ဝယ်ယူသည့်နေ့စွဲ",
    "inventory.label.Supplier Code": "ကုန်ကျစရိတ်နံပါတ်",
    "inventory.label.Entity Name": "လက်ခံသုံးစွဲအမည်",
    "inventory.label.Save": "သိမ်းမည်",
    "inventory.label.Cancel": "ပယ်ဖျက်မည်",
    "inventory.label.Edit": "ပြင်မည်",
    "inventory.label.Ok": "သဘောတူသည်",
    "inventory.label.Reset": "ပြန်လည်ตั้งစေပါ",
    "inventory.label.Update": "ပြုပြင်မည်",
    "inventory.label.PinNo": "ပင်နံပါတ်",
    "inventory.label.Delete": "ဖျက်မည်",
    "inventory.label.Value": "တန်ဖိုး",
    "inventory.label.Confirm": "အတည်ပြုပါ",
    "inventory.label.PinType": "ပင်အမျိုးအစား",
    "inventory.label.CustomerId": "ဖောက်သည်အိုင်ဒီ",
    "inventory.label.SerialNo": "စီရီယယ်နံပါတ်",
    "inventory.label.OfficeId": "ရုံးအိုင်ဒီ",
    "inventory.label.BatchName": "လော့ရှင်းအမည်",
    "inventory.label.ManageVoucherPins": "ဝါချာပင်များကိုစီမံမည်",
    "inventory.label.ContractType": "စာချုပ်အမျိုးအစား",
    "inventory.label.ContractUnit": "စာချုပ်အထွေထွေ",
    "inventory.label.ViewGoodsReceipt": "ကုန်စည်လက်ခံလွှာကိုကြည့်ပါ",
    "inventory.label.ViewItemDetail": "အထွေထွေတန်ဖိုးကိုကြည့်ပါ",
    "inventory.label.ItemDescription": "ကုန်ပစ္စည်းအကြောင်းအရာ",
    "inventory.label.OrderedQuantity": "အမိန့်အရေအတွက်",
    "inventory.label.ReceivedQuantity": "ရရှိသောအရေအတွက်",
    "inventory.label.AvailableActions": "ရရှိနိုင်သောအမှုများ",
    "inventory.label.RequestedDate": "တောင်းဆိုသောရက်စွဲ",
    "inventory.label.RequestedBy": "တောင်းဆိုသူ",
    "inventory.label.RequestedFrom": "တောင်းဆိုနေသောနေရာ",
    "inventory.label.business_entity_name": "Tên Thực thể Kinh doanh",
    "inventory.label.Item Description": "ကုန်ပစ္စည်းအကြောင်းအရာ",
    "inventory.label.Ordered Quantity": "အမှာစာအရောင်း",
    "inventory.label.Received Quantity": "လက်ခံသွင်းအရောင်း",
    "inventory.label.Balance Quantity": "ဘော်တန်းအရောင်း",
    "inventory.label.status": "အခြေအနေ",
    "inventory.label.action": "လုပ်ဆောင်ချက်",
    "inventory.label.Create Goods Receipt": "ကုန်ပစ္စည်းအားလုံးအတည်ပြုခြင်း",
    "inventory.label.Purchase No": "ဝယ်ယူခြင်းနံပါတ်",
    "inventory.label.Supplier": "ကုန်သည်",
    "inventory.label.Office Id": "ရုံးအချက်အလက် ID",
    "inventory.label.Item Code": "ပစ္စည်းကုဒ်",
    "inventory.label.Ordered Quantity": "အရွေ့ပြောင်းလဲခြင်း",
    "inventory.label.Edit Goods Receipt": "ကုန်ပစ္စည်းအားလုံးပြင်ဆင်ခြင်း",
    "stockUpload.label.header": "စတင်စာရင်းတင်ရန် ",
    "stockUpload.label.Entity Name": "ကောင်းကောင်းနာမည် ",
    "stockUpload.label.Item Description": "ကိုယ်ပိုင်နမူနာ ",
    "stockUpload.label.Item Code": "ကုဒ်ကုဒ်ကုဒ် ",
    "stockUpload.label.AccountNumber": "အကောင့်နံပါတ် ",
    "stockUpload.label.Chip Id": " ချီဖက်အိတ်",
    "stockUpload.label.Is Pairing": "မကျဆာဆာလေးသည်လျှင် ",
    "stockUpload.label.Paired ItemId": "မကျဆာဆာသည်ပိုင်ပိုင် ",
    "stockUpload.label.Paired Item": " အကောင့်နံပါတ်",
    "stockUpload.label.Serial Number": "အကြောင်းနံပါတ် ",
    "stockUpload.label.Warranty Date": " အကြောင်းနံပါတ်အမျိုးအစား",
    "stockUpload.label.Item Model": "ပြည့်နှစ်သက်ရာ ",
    "stockTransfer.label.header": "ကိုယ်ပိုင်အားပေးလျှင်",
    "stockTransfer.label.Id": "ID",
    "stockTransfer.label.Requested Date": "တောင်းခံသက်တမ်း",
    "stockTransfer.label.Requested By": "တောင်းသူ",
    "stockTransfer.label.Request From": "မေးခွန်းမှ",
    "stockTransfer.label.Item Description": "ပစ္စည်းဖောင့်ဖြစ်စေသည်",
    "stockTransfer.label.Ordered Quantity": "အရောင်းတွက်ရောက်သည်",
    "stockTransfer.label.Received Quantity": "ရယူခွင့်ပြုပြီး",
    "stockTransfer.label.Create Item Sale": "ကိုယ်စာရင်းတစ်ခုဖန်တီးရန်",
    "stockTransfer.label.Create MRN": "MRN ဖန်တီးရန်",
    "stockTransfer.label.Create GRV": "GRV ဖန်တီးရန်",
    "stockTransfer.label.Delete Item Sale":
      "ကိုယ်ရောက်စာရင်းကိုဖျက်ပြီးဆက်လက်မလုပ်သင့်ပါ",
    "stockTransfer.label.Are you sure?": "သေချာပါသလား?",
    "stockTransfer.label.Cancel": "ပယ်ဖျက်မည်",
    "stockTransfer.label.Ok": "အိုကေ",
    "stockUpload.label.add.Add Stock Upload": "စတုတ္ထုတ္ကို ထည့္သြင္းပါ",
    "stockUpload.label.add.Individual Load": "ကိုယ္တိုင္ခြင့္ ထုတ္ကို",
    "stockUpload.label.add.Bulk Load": "အဆိုပါထုတ္ကို",
    "stockUpload.label.add.GRN ID": "GRN အေရာင္း",
    "stockUpload.label.add.itemDescription": "ကုန္ပစၥည္းဖြဲ႕စည့္",
    "stockUpload.label.add.Suplier Code": "ေပးသူကုဒ္",
    "stockUpload.label.add.Received Quantity": "လက္ခံသည့္အရေတြက္",
    "stockUpload.label.add.Entity Name": "နာမည္",
    "stockUpload.label.add.Ordered Quantity": "အေတာင္းသည့္အရေတြက္",
    "stockUpload.label.add.Quality": "အရည္အေသြး",
    "stockUpload.label.add.Item Model": "ကုန္ပစၥည္းမ်ားအမ်ိဳးအစား",
    "stockUpload.label.add.OEM Type": "OEM အမ်ိဳးအစား",
    "stockUpload.label.add.LM Type": "LM အမ်ိဳးအစား",
    "stockUpload.label.add.Serial No": "စက္နာမည္",
    "stockUpload.label.add.Provision No": "ေရာင္းခ်သည့္နံပါတ္",
    "stockUpload.label.add.Paired Item": "တူညီသည့္ကုန္ပစၥည္း",
    "stockUpload.label.add.Is Paired": "တူညီထားသည္",
    "stockUpload.label.add.Remarks": "မွတ္ခ်က္မ်ား",
    "stockUpload.label.add.Carton No": "ကာတာနံပါတ္",
    "stockUpload.label.add.Select Name": "နာမည္ ေရြးခ်ယ္ပါ",
    "stockUpload.label.select_bulk_upload_type":
      "အစုလိုက်တင်ရန်အမျိုးအစားရွေးပါ",
    "stockUpload.label.add.Description": "ဖော်ပြချက်",
    "stockUpload.label.add.Reset": "ျပန္လည္သတ္မွတ္မည္",
    "stockUpload.label.add.Save": "သိမ္းဆည္းပါ",
    "stockUpload.label.add.Upload & Process": "ထည့္သြင္းနည္း၊ အလုပ္လုပ္ေဆာင္ပါ",
    "stockUpload.label.add.Upload Process": "ထည့္သြင္းလုပ္ေဆာင္ခ်က္",
    "stockUpload.label.add.Upload File Path": "ဖိုင္ထည့္သြင္းလမ္း",
    "stockUpload.label.add.Process Date": "လုပ္ငန္း ေန့ရက္",
    "stockUpload.label.add.Process/Total Records":
      "လုပ္ငန္း/စုစုေပါင္း မွတ္တမ္း",
    "Create StockUpload": "စတုတ္ထုတ္ခြင့္သည့္ စာရင္းသြင္းရန္",
    "Edit Item Detail": "ပစၥည္းအသစ္အရင္း ျပင္ဆင္ရန္",
    "Provision Serial Number": "ေရာင္းခ်သည့္ စီစဥ္ကုဒ္",
    "Serial Number": "စီစဥ္ကုဒ္",
    "Track History": "မွတ္တမ္း ထားရန္",
    "Ref Type": "သတိေပးပံုအမ်ဳိးအစား",
    "Transaction Date": "လုပ္ငန္းစာရင္းသြင္းရန္",
    Movement: "ေရႊ႕ရန္",
    "From Office": "အခ်ိန္ကန္မန္",
    "To Office": "အခ်ိန္အေရွ႕",
    Done: "ၿပီးပီ",
    Type: "အမ်ိဳးအစား",
    "Edit Item Sale": "ကုန်ပစ္စည်းအရောင်းပြောင်းရန်",
    Item: "ကုန်ပစ္စည်း",
    "From ORG": "မှ",
    "To ORG": "သို့",
    Charge: "ငွေပမာဏ",
    "Requested Quantity": "တောင်းဆိုမှုအရေအတွက်",
    "Unit Price": "အနုတ်ကျပ်",
    "Total Item Price": "ကုန်ပစ္စည်းအမျိုးစားသောင်းစတင်ခံရမည်",
    "Create Item Sale": "ကုန်ပစ္စည်းအရောင်းဖန်တီးရန်",
    "Purchased From": "မှာယူထားသည်",
    "Purchase By": "လက်ယာရယူသူ",
    "Discount Type": "လျှောက်လွှာအမျိုးအစား",
    "Discount Rate": "လျှောက်လွှာအလေးချိန်",
    "Delete Item Model": "ကုန်ပစ္စည်းအမျိုးအစားဖျက်ရန်",
    "View ItemSales": "ပစ္စည်းရောင်းချခြင်းကိုကြည့်ပါ",
    "Create MRN": "MRN ဖန်တီးပါ",
    "View MRN": "MRN ကြည့်ရန်",
    "Edit MRN": "MRN ပြင်ရန်",
    "Create GRV": "GRV ဖန်တီးပါ",
    "View GRV": "GRV ကြည့်ရန်",
    "Edit GRV": "GRV ပြင်ရန်",
    Notes: "မှတ်ချက်များ",
    "View Goods Receipt": "ပစ္စည်းလက်ခံရယူကုဒ်ကိုကြည့်ရန်",
    "MRN Id": "MRN အမှတ်",
    "Cartoon Transfer": "ကာတန်းပြောင်းခြင်း",
    "inventory.label.GoodsReceipt": "ကုန်စည်ပြေစာ",
    "inventory.label.StockUpload": "ကုန်ပစ္စည်း တင်ရန်",
    "inventory.label.StockTransfer": "ကုန်ပစ္စည်း အားလုံးပြင်ဆင်ရန်",
    "inventory.label.ItemSale": "ကုန်ပစ္စည်း ရောင်းချသည်",
    "inventory.label.MRN": "MRN",
    "inventory.label.GRV": "GRV",
    "inventory.label.Submit": "တင်သွင်းပါ",
  },

  my: {
    "inventory.label.EditGRV": "GRV ကိုတည်းဖြတ်ပါ",
    "inventory.label.Edit_MRN": "MRN ကိုတည်းဖြတ်ပါ",
"inventory.label.GoodsReceipt": "ကုန်ပစ္စည်းလက်ခံရရှိမှု",
    "inventory.label.DeleteItemDetail": "ပစ္စည်းအသေးစိတ် ဖျက်ရန်",
"inventory.label.EditQuality": "အရည်အသွေး တည်းဖြတ်ရန်",
"inventory.label.Quality": "အရည်အသွေး",
"inventory.label.ViewTraker": "ထောက်လှမ်းမှု ကြည့်ရန်",
"inventory.label.EntityName": "လုပ်ငန်းအမည်",
"inventory.label.ItemDescription": "ပစ္စည်းဖော်ပြချက်",
"inventory.label.ItemCode": "ပစ္စည်းကုဒ်",
"inventory.label.AccountNumber": "အကောင့်နံပါတ်",
"inventory.label.ChipId": "ချစ်ပ် ID",
"inventory.label.IsPairing": "တွဲဖက်ထားသည်",
"inventory.label.PairedItemId": "တွဲဖက် ID",
"inventory.label.PairedItem": "တွဲဖက်ထားသော ပစ္စည်း",
"inventory.label.WarrantyDate": "အာမခံသက်တမ်း",
"inventory.label.ItemModel": "ပစ္စည်းမော်ဒယ်",
"inventory.label.status": "အခြေအနေ",
"inventory.label.EditItemDetail": "အသေးစိတ် တည်းဖြတ်ရန်",
"inventory.label.CreateStockUpload": "စတော့အပ်လုဒ်ဖန်တီးရန်",
"inventory.label.SelectStatus": "အခြေအနေ ရွေးပါ",
"inventory.label.SelectDescription": "ဖော်ပြချက် ရွေးပါ",
"inventory.label.SelectBusinessEntity": "လုပ်ငန်း ရွေးပါ",
"inventory.label.Warranty": "အာမခံ",
"inventory.label.SupplierCode": "ပေးသွင်းသူ ကုဒ်",
"inventory.label.GrnId": "GRN ID",
"inventory.label.SerialNo": "စီးရီးနံပါတ်",
"inventory.label.ViewItemDetail": "အသေးစိတ်ကြည့်ရန်",
"inventory.label.Office": "ရုံး",
    "inventory.label.RefType": "ရည်ညွှန်းအမျိုးအစား",
  "inventory.label.TransactionDate": "ငွေလွှဲနေ့စွဲ",
  "inventory.label.Movement": "ရွှေ့ပြောင်းမှု",
  "inventory.label.FromOffice": "ရုံးမှ",
  "inventory.label.ToOffice": "ရုံးသို့",
  "inventory.label.TrackHistory": "မှတ်တမ်းလိုက်ခြင်း",
  "inventory.label.SerialNumber": "စီးရီးနံပါတ်",
  "inventory.label.ProvisionSerialNumber": "Provision စီးရီးနံပါတ်",
  "inventory.label.EditItemDetail": "ပစ္စည်းအသေးစိတ်ကို ပြင်ဆင်ပါ",
    "inventory.label.Download_Uploaded_File": "डाउनलोड अपलोड किया गया फ़ाइल",
    "inventory.label.Download_Log_File": "डाउनलोड लॉग फ़ाइल",
    "inventory.label.Description": "विवरण",
    "inventory.label.Browse_file_to_Upload": "अपलोड करने के लिए फ़ाइल ब्राउज़ करें",
    "inventory.label.Download_From_here": "यहां से डाउनलोड करें",
    "inventory.label.SelectItem": "आइटम चुनें",
    "inventory.label.SelectModel": "मॉडल चुनें",
    "inventory.label.Browse_file_to_Upload": "अपलोड करने के लिए फ़ाइल ब्राउज़ करें",
    "inventory.label.Download_From_here": "यहां से डाउनलोड करें",
    "inventory.label.MRN_Id": "MRN आईडी",
    "inventory.label.Type": "प्रकार",
    "inventory.label.CartoonTransfer": "कार्टून ट्रांसफर",
    "inventory.label.Are_you_sure_?": "သေခ်ာျပီလား?",
  "inventory.label.Done": "ၿပီးၿပီ",
  "inventory.label.RefType": "အညႊန္းအမ်ိဳးအစား",
  "inventory.label.Movement": "လႈပ္ရွားမႈ",
  "inventory.label.TransactionDate": "ငွေလႊဲသည့္ေန႔စြဲ",
  "inventory.label.ToOffice": "႐ုံးသို႔",
  "inventory.label.FromOffice": "႐ုံးမွ",
  "inventory.label.TrackHistory": "မွတ္တမ္းလိုက္နာမႈ",
  "inventory.label.SerialNumber": "စီးရီးနံပါတ္",
  "inventory.label.ProvisionSerialNumber": "Provision စီးရီးနံပါတ္",
  "inventory.label.SelectItem": "ပစၥည္းေရြးပါ",
  "inventory.label.Quality": "အရည္အေသြး",
  "inventory.label.EditItemDetail": "အခ်က္အလက္တည္းျဖတ္ရန္",
  "inventory.label.Assets": "ပိုင္ဆိုင္မႈမ်ား",
  "inventory.label.NoGenerator": "မရွိပါ",
  "inventory.label.Edit": "တည္းျဖတ္ပါ",
  "inventory.label.CreateStockUpload": "Stock Upload ဖန္တီးပါ",
  "inventory.label.Delete": "ဖ်က္ပါ",
  "inventory.label.View": "ၾကည့္ပါ",
  "inventory.label.SelectStatus": "အေျခအေန ေရြးခ်ယ္ပါ",
  "inventory.label.SelectDescription": "ဖာ္ျပခ်က္ ေရြးခ်ယ္ပါ",
  "inventory.label.SelectBusinessEntity": "စီးပြားေရးအဖြဲ႔အစည္း ေရြးခ်ယ္ပါ",
    "inventory.label.EditItemSale": "ပစ္စည်းရောင်းခြင်းကိုတည်းဖြတ်ပါ",
  "inventory.label.Item": "ပစ္စည်း",
  "inventory.label.TotalItemPrice": "ပစ္စည်းစုစုပေါင်းစျေးနှုန်း",
  "inventory.label.UnitPrice": "ယူနစ်စျေးနှုန်း",
  "inventory.label.RequestedQuantity": "တောင်းဆိုသောအရေအတွက်",
  "inventory.label.Charge": "ကောက်ခံငွေ",
  "inventory.label.To_ORG": "သို့ ORG",
  "inventory.label.ToOrganization": "အဖွဲ့အစည်းသို့",
  "inventory.label.FromOrganization": "အဖွဲ့အစည်းမှ",
  "inventory.label.From_ORG": "ORG မှ",
  "inventory.label.Type": "အမျိုးအစား",
  "inventory.label.Notes": "မှတ်ချက်များ",
    "inventory.label.SelectSearch": "ရှာဖွေမှုကို ရွေးပါ",
  "inventory.label.CreateGRV": "GRV ဖန်တီးရန်",
  "inventory.label.Type": "အမျိုးအစား",
  "inventory.label.Item": "အမျိုးအစား",
  "inventory.label.Notes": "မှတ်စုများ",
  "inventory.label.PurchasedFrom": "ဝယ်ယူခဲ့သောနေရာ",
  "inventory.label.PurchaseBy": "ဝယ်သူ",
  "inventory.label.Charge": "အခကြေးငွေ",
  "inventory.label.TotalItemPrice?": "စုစုပေါင်းကုန်ပစ္စည်းဈေးနှုန်း?",
  "inventory.label.DiscountType": "လျှော့စျေးအမျိုးအစား",
  "inventory.label.DiscountRate": "လျှော့စျေးနှုန်း",
  "inventory.label.UnitPrice": "ယူနစ်စျေးနှုန်း",
  "inventory.label.View_GRV": "GRV ကြည့်ရန်",
  "inventory.label.Delete": "ဖျက်ရန်",
  "inventory.label.DeleteItemModel": "ပစ္စည်းမော်ဒယ် ဖျက်ရန်",
  "inventory.label.View_MRN": "MRN ကြည့်ရန်",
  "inventory.label.View_ItemSales": "ပစ္စည်းရောင်းအား ကြည့်ရန်",
    "inventory.label.CreateNewContract": "စာချုပ်အသစ်ဖန်တီးပါ",
  "inventory.label.EditFeeMaster": "ကြေးအုပ်ချုပ်သူကိုတည်းဖြတ်ပါ",
  "inventory.label.GRVId": "GRV ID",
  "inventory.label.SerialNo": "အမွတ္စဥ္",
  "inventory.label.MRNId": "MRN ID",
  "inventory.label.SalesId": "အေရာင္း ID",
  "inventory.label.Are_you_sure?": "သေခ်ာပါသလား?",
  "inventory.label.DeleteItemSale": "ပစၥည္းေရာင္းခ်ျခင္းကိုဖ်က္ပါ",
  "inventory.label.delete": "ဖ်က္ပါ",
  "inventory.label.MoveCarton": "ကာတြန္ကိုေျပာင္းပါ",
  "inventory.label.MoveItems": "ပစၥည္းမ်ားကိုေျပာင္းပါ",
  "inventory.label.BulkStockTransfer": "စေတာ့အိတ္အမ်ားႀကီးကိုေျပာင္းျခင္း",
  "inventory.label.Create_MRN/GRV": "MRN/GRV ကိုဖန္တီးပါ",
  "inventory.label.CreateItemSale": "ပစၥည္းေရာင္းခ်မႈဖန္တီးပါ",
    "entity.label.Edit": "တည်းဖြတ်ရန်",
  "entity.label.Delete": "ဖျက်ရန်",
  "entity.label.DeleteItemModel": "အိုင်တမ်မော်ဒယ်ဖျက်ရန်",
  "entity.label.Item": "အိုင်တမ်",
  "entity.label.DeleteItem": "အိုင်တမ်ဖျက်ရန်",
    "inventory.label.DeleteItemDetails": "အမျိုးအစားအသေးစိတ်ကို ဖျက်ပါ",
    "inventory.label.header": "ပစ္စည်းလက်ခံသွင်း",
    "inventory.label.id": "အဆင့်",
    "inventory.label.Purchase Date": "ဝယ်ယူရက်",
    "inventory.label.Supplier Code": "ကုန်ပစ္စည်းကုဒ်",
    "inventory.label.Entity Name": "ပစ္စည်းနာမည်",
    "inventory.label.Save": "သိမ်းမည်",
    "inventory.label.Cancel": "မလုပ်တော့ပါ",
    "inventory.label.Edit": "ပြင်မည်",
    "inventory.label.Ok": "အတည်ပြုသည်",
    "inventory.label.Reset": "ပြန်လည်သတ်မှတ်ပါ",
    "inventory.label.Update": "အပ်ဒိတ်လုပ်ပါ",
    "inventory.label.PinNo": "ပင်နံပါတ်",
    "inventory.label.Delete": "ဖျက်မည်",
    "inventory.label.Value": "တန်ဖိုး",
    "inventory.label.Confirm": "အတည်ပြုပါ",
    "inventory.label.PinType": "ပင်အမျိုးအစား",
    "inventory.label.CustomerId": "ဖောက်သည်အိုင်ဒီ",
    "inventory.label.SerialNo": "စီရီယယ်နံပါတ်",
    "inventory.label.OfficeId": "ရုံးအိုင်ဒီ",
    "inventory.label.BatchName": "လော့ရှင်းအမည်",
    "inventory.label.ManageVoucherPins": "ဝါချာပင်များကိုစီမံပါ",
    "inventory.label.ContractType": "စာချုပ်အမျိုးအစား",
    "inventory.label.ContractUnit": "စာချုပ်အထွေထွေ",
    "inventory.label.ViewGoodsReceipt": "ကုန်စည်လက်ခံလွှာကိုကြည့်ပါ",
    "inventory.label.ViewItemDetail": "အထွေထွေတန်ဖိုးကိုကြည့်ပါ",
    "inventory.label.ItemDescription": "ကုန်ပစ္စည်းအကြောင်းအရာ",
    "inventory.label.OrderedQuantity": "အမိန့်အရေအတွက်",
    "inventory.label.ReceivedQuantity": "ရရှိသောအရေအတွက်",
    "inventory.label.AvailableActions": "ရရှိနိုင်သောအမှုများ",
    "inventory.label.RequestedDate": "တောင်းဆိုသောရက်စွဲ",
    "inventory.label.RequestedBy": "တောင်းဆိုသူ",
    "inventory.label.RequestedFrom": "တောင်းဆိုနေသောနေရာ",
    "inventory.label.business_entity_name": "စီးပွားရေးအဖွဲ့အစည်းအမည်",
    "inventory.label.Item Description": "ပစ္စည်းအကြောင်းအရာ",
    "inventory.label.Ordered Quantity": "အမှာစာအရောင်း",
    "inventory.label.Received Quantity": "ရယူခဲ့သည့်အရောင်း",
    "inventory.label.Balance Quantity": "လက်ခံခဲ့သည့်အရောင်း",
    "inventory.label.status": "အခြေအနေ",
    "inventory.label.action": "လုပ်ဆောင်ချက်",
    "inventory.label.Create Goods Receipt": "ကုန်ပစ္စည်းအားလုံးဖန်တီးပါ",
    "inventory.label.Purchase No": "ဝယ်ယူအမှတ်",
    "inventory.label.Supplier": "ကုန်သည်",
    "inventory.label.Office Id": "ရုံးအချက်အလက် ID",
    "inventory.label.Item Code": "ပစ္စည်းကုဒ်",
    "inventory.label.Ordered Quantity": "အရွေ့တောင်းခံခြင်း",
    "inventory.label.Edit Goods Receipt": "ကုန်ပစ္စည်းအားလုံးပြင်ဆင်ခြင်း",
    "stockUpload.label.header": "Muat naik Stok ",
    "stockUpload.label.Entity Name": " Nama Entiti",
    "stockUpload.label.Item Description": "Penerangan Item ",
    "stockUpload.label.Item Code": "Kod Item ",
    "stockUpload.label.AccountNumber": " Nombor Akaun",
    "stockUpload.label.Chip Id": "ID Cip ",
    "stockUpload.label.Is Pairing": " Adakah Berpasangan",
    "stockUpload.label.Paired ItemId": "ID Item Dipasangkan ",
    "stockUpload.label.Paired Item": " Item Dipasangkan",
    "stockUpload.label.Serial Number": " Nombor Siri",
    "stockUpload.label.Warranty Date": " Tarikh Jaminan",
    "stockUpload.label.Item Model": " Model Item",
    "stockTransfer.label.header": "ကိုယ်ပိုင်အားပေးလျှင်",
    "stockTransfer.label.Id": "ID",
    "stockTransfer.label.Requested Date": "တောင်းခံသက်တမ်း",
    "stockTransfer.label.Requested By": "တောင်းသူ",
    "stockTransfer.label.Request From": "မေးခွန်းမှ",
    "stockTransfer.label.Item Description": "ပစ္စည်းဖောင့်ဖြစ်စေသည်",
    "stockTransfer.label.Ordered Quantity": "အရောင်းတွက်ရောက်သည်",
    "stockTransfer.label.Received Quantity": "ရယူခွင့်ပြုပြီး",
    "stockTransfer.label.Create Item Sale": "ကိုယ်စာရင်းတစ်ခုဖန်တီးရန်",
    "stockTransfer.label.Create MRN": "MRN ဖန်တီးရန်",
    "stockTransfer.label.Create GRV": "GRV ဖန်တီးရန်",
    "stockTransfer.label.Delete Item Sale":
      "ကိုယ်ရောက်စာရင်းကိုဖျက်ပြီးဆက်လက်မလုပ်သင့်ပါ",
    "stockTransfer.label.Are you sure?": "သေချာပါသလား?",
    "stockTransfer.label.Cancel": "ပယ်ဖျက်မည်",
    "stockTransfer.label.Ok": "အိုကေ",
    "stockUpload.label.add.Add Stock Upload": "စတင်ထုတ်သည့်ပစ္စည်းထည့်သည်",
    "stockUpload.label.add.Individual Load": "ကိုယ်တိုင်ခြင်းတင်ထုတ်သည်",
    "stockUpload.label.add.Bulk Load": "အထွေထွေတင်ထုတ်သည်",
    "stockUpload.label.add.GRN ID": "GRN အမှတ်",
    "stockUpload.label.add.itemDescription": "ပစ္စည်းအကြောင်းအရာ",
    "stockUpload.label.add.Suplier Code": "ကုန်သည်များကုဒ်",
    "stockUpload.label.add.Received Quantity": "ရရှိသည့်အရေတွက်",
    "stockUpload.label.add.Entity Name": "ကုန်ပစ္စည်းအမည်",
    "stockUpload.label.add.Ordered Quantity": "အော်ဒါများကိုအရေတွက်ထည့်သည်",
    "stockUpload.label.add.Quality": "အရည်အသွေး",
    "stockUpload.label.add.Item Model": "ကုန်ပစ္စည်းများအမျိုးအစား",
    "stockUpload.label.add.OEM Type": "OEM အမျိုးအစား",
    "stockUpload.label.add.LM Type": "LM အမျိုးအစား",
    "stockUpload.label.add.Serial No": "စက်နံပါတ်",
    "stockUpload.label.add.Provision No": "အသောက်တန်းနံပါတ်",
    "stockUpload.label.add.Paired Item": "တူဝန်စွာပြုလုပ်ခြင်း",
    "stockUpload.label.add.Is Paired": "တူဝန်ပြီးသည်",
    "stockUpload.label.add.Remarks": "မှတ်ချက်များ",
    "stockUpload.label.add.Carton No": "ကာတွန်နံပါတ်",
    "stockUpload.label.add.Select Name": "အမည်ရွေးချယ်ရန်",
    "stockUpload.label.select_bulk_upload_type":
      "အစုလိုက်တင်ရန်အမျိုးအစားရွေးပါ",
    "stockUpload.label.add.Description": "ဖော်ပြချက်",
    "stockUpload.label.add.Reset": "ပြန်လည်သတ်မှတ်ရန်",
    "stockUpload.label.add.Save": "သိမ်းဆည်းပါ",
    "stockUpload.label.add.Upload & Process": "တင်သွင်းနှင့်ဖြစ်ပြီးစီစစ်ဆေးပါ",
    "stockUpload.label.add.Upload Process":
      "တင်သွင်းလုပ်ဆေးနှင့်ဖြစ်ပြီးစီစစ်ဆေးပါ",
    "stockUpload.label.add.Upload File Path":
      "ဖိုင်သိုလှောင်ပစ္စည်းထည့်သည့်လမ်း",
    "stockUpload.label.add.Process Date": "ဆေးဆိုလိုင်းရက်",
    "stockUpload.label.add.Process/Total Records":
      "ဆေးဆိုလိုင်း/စုစုပေါင်းမှတ်တမ်း",
    "Create StockUpload": "စတင်ထုတ်သည့်ပစ္စည်းထည့်သည်",
    "Edit Item Detail": "ပစ္စည်းအသေးစိတ်အမှတ်စာရင်းပြင်ရန်",
    "Provision Serial Number": "စနီးအသင်းကုဒ်",
    "Serial Number": "စနီးကုဒ်",
    "Track History": "မှတ်တမ်းရှိသောသမိုင်း",
    "Ref Type": "အမည်ရိုက်အနှုန်း",
    "Transaction Date": "ငွေလွဲစာရင်း",
    Movement: "မှတ်ရလွှင့်",
    "From Office": "မှ",
    "To Office": "သို့သွားသည်",
    Done: "ပြီးပြီ",
    Type: "အမျိုးအစား",
    "Edit Item Sale": "ကုန်ပစ္စည်းရောင်းမှုတည်းဖြတ်ပါ",
    Item: "ကုန်ပစ္စည်း",
    "From ORG": "မှ",
    "To ORG": "သို့",
    Charge: "ငွေပမာဏ",
    "Requested Quantity": "တောင်းဆိုမှုအရေအတွက်",
    "Unit Price": "အနုတ်ကျပ်",
    "Total Item Price": "ကုန်ပစ္စည်းအရောင်းစစ်တင်ခြင်း",
    "Create Item Sale": "ကုန်ပစ္စည်းရောင်းမှုတည်းဖြတ်ပါ",
    "Purchased From": "မှာယူထားသောကုန်ပစ္စည်း",
    "Purchase By": "လက်ယာရယူသူ",
    "Discount Type": "လျှောက်လွှာအမျိုးအစား",
    "Discount Rate": "လျှောက်လွှာအလေးချိန်",
    "Delete Item Model": "ကုန်ပစ္စည်းများဖျက်ပါ",
    "View ItemSales": "ഉൽപ്പന്നത്തിന്റെ വിൽപ്പന കാണുക",
    "Create MRN": "MRN ဖန်တီးပါ",
    "View MRN": "MRN ကြည့်ရန်",
    "Edit MRN": "MRN ပြင်ရန်",
    "Create GRV": "GRV ဖန်တီးပါ",
    "View GRV": "GRV ကြည့်ရန်",
    "Edit GRV": "GRV ပြင်ရန်",
    Notes: "မှတ်ချက်များ",
    "View Goods Receipt": "ပစ္စည်းလက်ခံရယူကုဒ်ကိုကြည့်ရန်",
    "MRN Id": "MRN အမှတ်",
    "Cartoon Transfer": "ကာတန်းပြောင်းခြင်း",
    "inventory.label.GoodsReceipt": "ကုန်စည်ပြေစာ",
    "inventory.label.StockUpload": "ကုန်ပစ္စည်း တင်ရန်",
    "inventory.label.StockTransfer": "ကုန်ပစ္စည်း အားလုံးပြင်ဆင်ရန်",
    "inventory.label.ItemSale": "ကုန်ပစ္စည်း ရောင်းချသည်",
    "inventory.label.MRN": "MRN",
    "inventory.label.GRV": "GRV",
    "inventory.label.Submit": "တင်သွင်းပါ",
  },

  vi: {
    "inventory.label.EditGRV": "Chỉnh sửa GRV",
    "inventory.label.Edit_MRN": "Chỉnh sửa MRN",
"inventory.label.GoodsReceipt": "Nhận hàng hóa",
    "inventory.label.CreateMRN": "Tạo MRN",
    "inventory.label.DeleteItemDetail": "Xóa chi tiết mặt hàng",
"inventory.label.EditQuality": "Chỉnh sửa chất lượng",
"inventory.label.Quality": "Chất lượng",
"inventory.label.ViewTraker": "Xem theo dõi",
"inventory.label.EntityName": "Tên pháp nhân",
"inventory.label.ItemDescription": "Mô tả mặt hàng",
"inventory.label.ItemCode": "Mã mặt hàng",
"inventory.label.AccountNumber": "Số tài khoản",
"inventory.label.ChipId": "ID chip",
"inventory.label.IsPairing": "Ghép cặp",
"inventory.label.PairedItemId": "ID mặt hàng ghép cặp",
"inventory.label.PairedItem": "Mặt hàng đã ghép cặp",
"inventory.label.WarrantyDate": "Ngày bảo hành",
"inventory.label.ItemModel": "Mẫu mặt hàng",
"inventory.label.status": "Trạng thái",
"inventory.label.EditItemDetail": "Chỉnh sửa chi tiết",
"inventory.label.CreateStockUpload": "Tạo tải lên kho",
"inventory.label.SelectStatus": "Chọn trạng thái",
"inventory.label.SelectDescription": "Chọn mô tả",
"inventory.label.SelectBusinessEntity": "Chọn pháp nhân",
"inventory.label.Warranty": "Bảo hành",
"inventory.label.SupplierCode": "Mã nhà cung cấp",
"inventory.label.GrnId": "GRN ID",
"inventory.label.SerialNo": "Số serial",
"inventory.label.ViewItemDetail": "Xem chi tiết",
"inventory.label.Office": "Văn phòng",
    "inventory.label.RefType": "Loại tham chiếu",
  "inventory.label.TransactionDate": "Ngày giao dịch",
  "inventory.label.Movement": "Di chuyển",
  "inventory.label.FromOffice": "Từ văn phòng",
  "inventory.label.ToOffice": "Đến văn phòng",
  "inventory.label.TrackHistory": "Theo dõi lịch sử",
  "inventory.label.SerialNumber": "Số sê-ri",
  "inventory.label.ProvisionSerialNumber": "Số sê-ri dự phòng",
  "inventory.label.EditItemDetail": "Chỉnh sửa chi tiết mặt hàng",
    "inventory.label.Download_Uploaded_File": "Tải tệp đã tải lên",
    "inventory.label.Download_Log_File": "Tải tệp nhật ký",
    "inventory.label.Description": "Mô tả",
    "inventory.label.Browse_file_to_Upload": "Duyệt tệp để tải lên",
    "inventory.label.Download_From_here": "Tải xuống từ đây",
    "inventory.label.SelectItem": "Chọn món",
    "inventory.label.SelectModel": "Chọn mô hình",
    "inventory.label.Browse_file_to_Upload": "Duyệt tệp để tải lên",
    "inventory.label.Download_From_here": "Tải xuống từ đây",
    "inventory.label.MRN_Id": "ID MRN",
    "inventory.label.Type": "Loại",
    "inventory.label.CartoonTransfer": "Chuyển giao hoạt hình",
    "inventory.label.Are_you_sure_?": "Bạn có chắc không?",
  "inventory.label.Done": "Hoàn thành",
  "inventory.label.RefType": "Loại tham chiếu",
  "inventory.label.Movement": "Di chuyển",
  "inventory.label.TransactionDate": "Ngày giao dịch",
  "inventory.label.ToOffice": "Văn phòng đến",
  "inventory.label.FromOffice": "Văn phòng từ",
  "inventory.label.TrackHistory": "Lịch sử theo dõi",
  "inventory.label.SerialNumber": "Số serial",
  "inventory.label.ProvisionSerialNumber": "Số serial Provision",
  "inventory.label.SelectItem": "Chọn món hàng",
  "inventory.label.Quality": "Chất lượng",
  "inventory.label.EditItemDetail": "Chỉnh sửa chi tiết món hàng",
  "inventory.label.Assets": "Tài sản",
  "inventory.label.NoGenerator": "Không có máy phát",
  "inventory.label.Edit": "Chỉnh sửa",
  "inventory.label.CreateStockUpload": "Tạo tải lên kho",
  "inventory.label.Delete": "Xóa",
  "inventory.label.View": "Xem",
  "inventory.label.SelectStatus": "Chọn trạng thái",
  "inventory.label.SelectDescription": "Chọn mô tả",
  "inventory.label.SelectBusinessEntity": "Chọn thực thể kinh doanh",
    "inventory.label.EditItemSale": "Chỉnh sửa bán hàng",
  "inventory.label.Item": "Mặt hàng",
  "inventory.label.TotalItemPrice": "Tổng giá mặt hàng",
  "inventory.label.UnitPrice": "Đơn giá",
  "inventory.label.RequestedQuantity": "Số lượng yêu cầu",
  "inventory.label.Charge": "Phí",
  "inventory.label.To_ORG": "Đến ORG",
  "inventory.label.ToOrganization": "Đến tổ chức",
  "inventory.label.FromOrganization": "Từ tổ chức",
  "inventory.label.From_ORG": "Từ ORG",
  "inventory.label.Type": "Loại",
  "inventory.label.Notes": "Ghi chú",
    "inventory.label.SelectSearch": "Chọn tìm kiếm",
  "inventory.label.CreateGRV": "Tạo GRV",
  "inventory.label.Type": "Loại",
  "inventory.label.Item": "Mặt hàng",
  "inventory.label.Notes": "Ghi chú",
  "inventory.label.PurchasedFrom": "Mua từ",
  "inventory.label.PurchaseBy": "Mua bởi",
  "inventory.label.Charge": "Phí",
  "inventory.label.TotalItemPrice?": "Tổng giá mặt hàng?",
  "inventory.label.DiscountType": "Loại giảm giá",
  "inventory.label.DiscountRate": "Tỷ lệ giảm giá",
  "inventory.label.UnitPrice": "Đơn giá",
  "inventory.label.View_GRV": "Xem GRV",
  "inventory.label.Delete": "Xóa",
  "inventory.label.DeleteItemModel": "Xóa mẫu vật phẩm",
  "inventory.label.View_MRN": "Xem MRN",
  "inventory.label.View_ItemSales": "Xem doanh số sản phẩm",
    "inventory.label.CreateNewContract": "Tạo hợp đồng mới",
  "inventory.label.EditFeeMaster": "Chỉnh sửa phí chính",
  "inventory.label.GRVId": "Mã GRV",
  "inventory.label.SerialNo": "Số sê-ri",
  "inventory.label.MRNId": "Mã MRN",
  "inventory.label.SalesId": "Mã bán hàng",
  "inventory.label.Are_you_sure?": "Bạn có chắc không?",
  "inventory.label.DeleteItemSale": "Xóa bán hàng mặt hàng",
  "inventory.label.delete": "Xóa",
  "inventory.label.MoveCarton": "Di chuyển thùng",
  "inventory.label.MoveItems": "Di chuyển các mặt hàng",
  "inventory.label.BulkStockTransfer": "Chuyển kho số lượng lớn",
  "inventory.label.Create_MRN/GRV": "Tạo MRN/GRV",
  "inventory.label.CreateItemSale": "Tạo bán hàng mặt hàng",
    "entity.label.Edit": "Chỉnh sửa",
  "entity.label.Delete": "Xóa",
  "entity.label.DeleteItemModel": "Xóa mô hình mặt hàng",
  "entity.label.Item": "Mặt hàng",
  "entity.label.DeleteItem": "Xóa mặt hàng",
    "inventory.label.DeleteItemDetails": "Xóa chi tiết mục",
    "inventory.label.header": "Biên nhận hàng hóa",
    "inventory.label.id": "ID",
    "inventory.label.Purchase Date": "Ngày mua hàng",
    "inventory.label.Supplier Code": "Mã nhà cung cấp",
    "inventory.label.Entity Name": "Tên thực thể",
    "inventory.label.Save": "Lưu",
    "inventory.label.Cancel": "Hủy",
    "inventory.label.Edit": "Chỉnh sửa",
    "inventory.label.Ok": "Đồng ý",
    "inventory.label.Reset": "Đặt lại",
    "inventory.label.Update": "Cập nhật",
    "inventory.label.PinNo": "Số PIN",
    "inventory.label.Delete": "Xóa",
    "inventory.label.Value": "Giá trị",
    "inventory.label.Confirm": "Xác nhận",
    "inventory.label.PinType": "Loại PIN",
    "inventory.label.CustomerId": "ID Khách hàng",
    "inventory.label.SerialNo": "Số sê-ri",
    "inventory.label.OfficeId": "ID Văn phòng",
    "inventory.label.BatchName": "Tên lô hàng",
    "inventory.label.ManageVoucherPins": "Quản lý PIN phiếu",
    "inventory.label.ContractType": "Loại hợp đồng",
    "inventory.label.ContractUnit": "Đơn vị hợp đồng",
    "inventory.label.ViewGoodsReceipt": "Xem hóa đơn hàng hóa",
    "inventory.label.ViewItemDetail": "Xem chi tiết mặt hàng",
    "inventory.label.ItemDescription": "Mô tả mặt hàng",
    "inventory.label.OrderedQuantity": "Số lượng đặt hàng",
    "inventory.label.ReceivedQuantity": "Số lượng nhận",
    "inventory.label.AvailableActions": "Hành động khả dụng",
    "inventory.label.RequestedDate": "Ngày yêu cầu",
    "inventory.label.RequestedBy": "Yêu cầu bởi",
    "inventory.label.RequestedFrom": "Yêu cầu từ",
    "inventory.label.business_entity_name": "စီးပွားရေးအဖွဲ့အစည်းအမည်",
    "inventory.label.Item Description": "Mô tả mặt hàng",
    "inventory.label.Ordered Quantity": "Số lượng đặt hàng",
    "inventory.label.Received Quantity": "Số lượng đã nhận",
    "inventory.label.Balance Quantity": "Số lượng còn lại",
    "inventory.label.status": "Trạng thái",
    "inventory.label.action": "Hành động",
    "inventory.label.Create Goods Receipt": "Tạo biên nhận hàng hóa",
    "inventory.label.Purchase No": "Số mua hàng",
    "inventory.label.Supplier": "Nhà cung cấp",
    "inventory.label.Office Id": "ID Văn phòng",
    "inventory.label.Item Code": "Mã mặt hàng",
    "inventory.label.Ordered Quantity": "Số lượng đã đặt",
    "inventory.label.Edit Goods Receipt": "Chỉnh sửa biên nhận hàng hóa",
    "stockUpload.label.header": "  Tải lên Kho",
    "stockUpload.label.Entity Name": " Tên thực thể",
    "stockUpload.label.Item Description": "Mô tả mặt hàng ",
    "stockUpload.label.Item Code": " Mã mặt hàng",
    "stockUpload.label.AccountNumber": "Số tài khoản ",
    "stockUpload.label.Chip Id": " ID Chip",
    "stockUpload.label.Is Pairing": " Có đang ghép nối không",
    "stockUpload.label.Paired ItemId": "ID mặt hàng đã ghép nối ",
    "stockUpload.label.Paired Item": "Mặt hàng đã ghép nối ",
    "stockUpload.label.Serial Number": " Số serial",
    "stockUpload.label.Warranty Date": "Ngày bảo hành ",
    "stockUpload.label.Item Model": "Mô hình mặt hàng ",
    "stockTransfer.label.header": "Chuyển khoản hàng tồn",
    "stockTransfer.label.Id": "ID",
    "stockTransfer.label.Requested Date": "Ngày yêu cầu",
    "stockTransfer.label.Requested By": "Yêu cầu bởi",
    "stockTransfer.label.Request From": "Yêu cầu từ",
    "stockTransfer.label.Item Description": "Mô tả mặt hàng",
    "stockTransfer.label.Ordered Quantity": "Số lượng đặt hàng",
    "stockTransfer.label.Received Quantity": "Số lượng nhận được",
    "stockTransfer.label.Create Item Sale": "Tạo bán mặt hàng",
    "stockTransfer.label.Create MRN": "Tạo MRN",
    "stockTransfer.label.Create GRV": "Tạo GRV",
    "stockTransfer.label.Delete Item Sale": "Xóa bán mặt hàng",
    "stockTransfer.label.Are you sure?": "Bạn có chắc chắn không?",
    "stockTransfer.label.Cancel": "Hủy",
    "stockTransfer.label.Ok": "Đồng ý",
    "stockUpload.label.add.Add Stock Upload": "Thêm Tải lên Hàng tồn kho",
    "stockUpload.label.add.Individual Load": "Tải Lên Cá Nhân",
    "stockUpload.label.add.Bulk Load": "Tải Lên Hàng Loạt",
    "stockUpload.label.add.GRN ID": "ID GRN",
    "stockUpload.label.add.itemDescription": "Mô tả Sản phẩm",
    "stockUpload.label.add.Suplier Code": "Mã Nhà cung cấp",
    "stockUpload.label.add.Received Quantity": "Số Lượng Nhận Được",
    "stockUpload.label.add.Entity Name": "Tên Thực Thể",
    "stockUpload.label.add.Ordered Quantity": "Số Lượng Đã Đặt Hàng",
    "stockUpload.label.add.Quality": "Chất Lượng",
    "stockUpload.label.add.Item Model": "Mô Hình Sản Phẩm",
    "stockUpload.label.add.OEM Type": "Loại OEM",
    "stockUpload.label.add.LM Type": "Loại LM",
    "stockUpload.label.add.Serial No": "Số Sê-ri",
    "stockUpload.label.add.Provision No": "Số Đặc biệt",
    "stockUpload.label.add.Paired Item": "Sản Phẩm Đã Ghép",
    "stockUpload.label.add.Is Paired": "Đã Ghép",
    "stockUpload.label.add.Remarks": "Ghi chú",
    "stockUpload.label.add.Carton No": "Số Thùng",
    "stockUpload.label.add.Select Name": "Chọn Tên",
    "stockUpload.label.add.Description": "Mô tả",
    "stockUpload.label.add.Reset": "Đặt Lại",
    "stockUpload.label.add.Save": "Lưu",
    "stockUpload.label.add.Upload & Process": "Tải Lên và Xử Lý",
    "stockUpload.label.add.Upload Process": "Quy trình Tải Lên",
    "stockUpload.label.add.Upload File Path": "Đường dẫn Tải Lên Tệp",
    "stockUpload.label.add.Process Date": "Ngày Xử Lý",
    "stockUpload.label.add.Process/Total Records": "Bản Ghi/Xử Lý Tổng",
    "Create StockUpload": "Tạo Tải lên Hàng tồn kho",
    "Edit Item Detail": "Chỉnh sửa Chi tiết Mặt hàng",
    "Provision Serial Number": "Số Serial Dự phòng",
    "Serial Number": "Số Serial",
    "Track History": "Lịch sử Theo dõi",
    "Ref Type": "Loại Tham chiếu",
    "Transaction Date": "Ngày Giao dịch",
    Movement: "Chuyển động",
    "From Office": "Từ Văn phòng",
    "To Office": "Đến Văn phòng",
    Done: "Hoàn tất",
    Type: "Loại",
    "Edit Item Sale": "Chỉnh sửa Bán mặt hàng",
    Item: "Mặt hàng",
    "From ORG": "Từ Tổ chức",
    "To ORG": "Đến Tổ chức",
    Charge: "Phí",
    "Requested Quantity": "Số lượng Yêu cầu",
    "Unit Price": "Đơn giá",
    "Total Item Price": "Tổng giá mặt hàng",
    "Create Item Sale": "Tạo Bán mặt hàng",
    "Purchased From": "Được mua từ",
    "Purchase By": "Mua bởi",
    "Discount Type": "Loại giảm giá",
    "Discount Rate": "Tỷ lệ giảm giá",
    "Delete Item Model": "Xóa Mô hình Mặt hàng",
    "View ItemSales": "Xem bán hàng",
    "Create MRN": "Tạo MRN",
    "View MRN": "Xem MRN",
    "Edit MRN": "Chỉnh sửa MRN",
    "Create GRV": "Tạo GRV",
    "View GRV": "Xem GRV",
    "Edit GRV": "Chỉnh sửa GRV",
    Notes: "Ghi chú",
    "View Goods Receipt": "Xem biên nhận hàng hóa",
    "MRN Id": "ID MRN",
    "Cartoon Transfer": "Chuyển phim hoạt hình",
    "inventory.label.GoodsReceipt": "Biên nhận hàng hóa",
    "inventory.label.StockUpload": "Tải Lên Kho Hàng",
    "inventory.label.StockTransfer": "Chuyển Kho Hàng",
    "inventory.label.ItemSale": "Bán Hàng",
    "inventory.label.MRN": "MRN",
    "inventory.label.GRV": "GRV",
    "inventory.label.Submit": "Gửi",
  },
};
